import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import _36x181 from "./36x181.png";
import _36x182 from "./36x182.png";
import _36x183 from "./36x183.png";

const width = '100%'
const height = 'auto'
const viewBox = '0 0 1017 311'

const getDimensions = (size, sizes) => {
  if (size && typeof size.width === 'number' && typeof size.height === 'number') {
    return size
  }
  return size && sizes[size]
    ? sizes[size]
    : { width, height }
}

const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
  if (noStyles) { return '' }
  const dimensions = getDimensions(size, sizes)
  const fillRule = fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : ''
  return css`
    width: ${dimensions.width};
    height: ${dimensions.height};
    ${fillRule}
  `
}

const propsToCss = ({
  size,
  sizes,
  fillColor,
  fillColorRule,
  noStyles
}) => getCss(size, sizes, fillColor, fillColorRule, noStyles)

const Image = styled.svg`${propsToCss}`

const children = (
  <Fragment>
    <defs
      key='key-0'
    >
      <linearGradient
        id='s-5483b7a313-a'
        x1='-2375.55'
        x2='-2375.3'
        y1='302.87'
        y2='302.87'
        gradientTransform='matrix(-1 0 0 1 -2127.14 -220.08)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#595959'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#5c5c5c'
        />
      </linearGradient>
      <linearGradient
        id='s-5483b7a313-h'
        x1='-2374.36'
        x2='-2374.11'
        y1='302.81'
        y2='302.81'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-i'
        x1='-2373.25'
        x2='-2373'
        y1='302.76'
        y2='302.76'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-j'
        x1='-2372.14'
        x2='-2371.89'
        y1='302.67'
        y2='302.67'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-k'
        x1='-2370.95'
        x2='-2370.7'
        y1='302.61'
        y2='302.61'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-l'
        x1='-2369.84'
        x2='-2369.59'
        y1='302.54'
        y2='302.54'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-m'
        x1='-2368.72'
        x2='-2368.47'
        y1='302.47'
        y2='302.47'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-n'
        x1='-2367.53'
        x2='-2367.28'
        y1='302.4'
        y2='302.4'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-o'
        x1='-2366.42'
        x2='-2366.17'
        y1='302.34'
        y2='302.34'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-p'
        x1='-2365.31'
        x2='-2365.06'
        y1='302.28'
        y2='302.28'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-q'
        x1='-2364.12'
        x2='-2363.87'
        y1='302.23'
        y2='302.23'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-r'
        x1='-2363.01'
        x2='-2362.76'
        y1='302.11'
        y2='302.11'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-s'
        x1='-2361.93'
        x2='-2361.68'
        y1='302.05'
        y2='302.05'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-t'
        x1='-2360.74'
        x2='-2360.49'
        y1='302.02'
        y2='302.02'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-u'
        x1='-2359.63'
        x2='-2359.38'
        y1='301.95'
        y2='301.95'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-v'
        x1='-2378.82'
        x2='-2362.54'
        y1='291.69'
        y2='291.69'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-w'
        x1='-2378.81'
        x2='-2362.53'
        y1='290.24'
        y2='290.24'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-x'
        x1='-2378.8'
        x2='-2362.53'
        y1='288.86'
        y2='288.86'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-y'
        x1='-2378.8'
        x2='-2362.52'
        y1='287.4'
        y2='287.4'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-z'
        x1='-2378.79'
        x2='-2362.52'
        y1='286.02'
        y2='286.02'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-A'
        x1='-2378.93'
        x2='-2362.65'
        y1='321.38'
        y2='321.38'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-B'
        x1='-2378.93'
        x2='-2362.65'
        y1='322.59'
        y2='322.59'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-C'
        x1='-2378.92'
        x2='-2362.64'
        y1='320'
        y2='320'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-D'
        x1='-2378.91'
        x2='-2362.64'
        y1='318.55'
        y2='318.55'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-E'
        x1='-2378.91'
        x2='-2362.63'
        y1='317.17'
        y2='317.17'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-F'
        x1='-2378.9'
        x2='-2362.63'
        y1='315.71'
        y2='315.71'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-G'
        x1='-2378.9'
        x2='-2362.62'
        y1='314.33'
        y2='314.33'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-H'
        x1='-2378.89'
        x2='-2362.62'
        y1='312.88'
        y2='312.88'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-I'
        x1='-2378.89'
        x2='-2362.61'
        y1='311.49'
        y2='311.49'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-J'
        x1='-2378.88'
        x2='-2362.61'
        y1='310.04'
        y2='310.04'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-K'
        x1='-2378.88'
        x2='-2362.6'
        y1='308.62'
        y2='308.62'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-L'
        x1='-2378.87'
        x2='-2362.6'
        y1='307.17'
        y2='307.17'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-M'
        x1='-2378.87'
        x2='-2362.59'
        y1='305.79'
        y2='305.79'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-N'
        x1='-2378.86'
        x2='-2362.59'
        y1='304.33'
        y2='304.33'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-O'
        x1='-2378.86'
        x2='-2362.58'
        y1='302.95'
        y2='302.95'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-P'
        x1='-2378.85'
        x2='-2362.57'
        y1='301.5'
        y2='301.5'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-Q'
        x1='-2378.85'
        x2='-2362.57'
        y1='300.12'
        y2='300.12'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-R'
        x1='-2378.84'
        x2='-2362.56'
        y1='298.66'
        y2='298.66'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-S'
        x1='-2378.84'
        x2='-2362.56'
        y1='297.28'
        y2='297.28'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-T'
        x1='-2378.83'
        x2='-2362.55'
        y1='295.83'
        y2='295.83'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-U'
        x1='-2378.83'
        x2='-2362.55'
        y1='294.45'
        y2='294.45'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-V'
        x1='-2378.82'
        x2='-2362.54'
        y1='292.99'
        y2='292.99'
        gradientTransform='matrix(-.99 0 0 1 -2114.13 -212.56)'
        xlinkHref='#s-5483b7a313-a'
      />
      <linearGradient
        id='s-5483b7a313-W'
        x1='230.75'
        x2='249.86'
        y1='81.77'
        y2='81.77'
        xlinkHref='#s-5483b7a313-a'
      />
      <radialGradient
        id='s-5483b7a313-X'
        cx='234.17'
        cy='78.51'
        r='1.36'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#999'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </radialGradient>
      <linearGradient
        id='s-5483b7a313-Y'
        x1='243.05'
        x2='243.08'
        y1='299.13'
        y2='298.61'
        gradientTransform='matrix(1.11 .01 .01 1 -35.47 -221.6)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </linearGradient>
      <linearGradient
        id='s-5483b7a313-Z'
        x1='1992.71'
        x2='1992.95'
        y1='734.49'
        y2='734.01'
        gradientTransform='rotate(-27.38 391.605 3461.088)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#d45a24'
        />
        <stop
          offset='.84'
          stopColor='#a2272d'
        />
      </linearGradient>
      <linearGradient
        id='s-5483b7a313-aa'
        x1='743.24'
        x2='743.69'
        y1='1029.69'
        y2='1029.84'
        gradientTransform='matrix(-.28 -1.17 .81 -.19 -66.1 1371.56)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#f15a24'
        />
        <stop
          offset='.83'
          stopColor='#a6272d'
        />
      </linearGradient>
      <linearGradient
        id='s-5483b7a313-b'
        x1='557.42'
        x2='557.6'
        y1='302.56'
        y2='302.56'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#be1e2d'
        />
        <stop
          offset='1'
          stopColor='#ee4036'
        />
      </linearGradient>
      <linearGradient
        id='s-5483b7a313-ab'
        x1='555.68'
        x2='565.8'
        y1='303.77'
        y2='303.77'
        xlinkHref='#s-5483b7a313-b'
      />
      <linearGradient
        id='s-5483b7a313-c'
        x1='549.24'
        x2='551.74'
        y1='132.5'
        y2='132.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#333'
        />
        <stop
          offset='.51'
          stopColor='#999'
        />
        <stop
          offset='1'
          stopColor='#333'
        />
      </linearGradient>
      <linearGradient
        id='s-5483b7a313-f'
        x1='507.19'
        x2='546.35'
        y1='152.07'
        y2='152.07'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#e6e6e6'
        />
        <stop
          offset='1'
          stopColor='#f2f2f2'
        />
      </linearGradient>
      <linearGradient
        id='s-5483b7a313-ac'
        x1='498.57'
        x2='501.07'
        y1='200.35'
        y2='200.35'
        xlinkHref='#s-5483b7a313-c'
      />
      <linearGradient
        id='s-5483b7a313-d'
        x1='-1541.27'
        x2='-1534.97'
        y1='327.32'
        y2='327.32'
        gradientTransform='matrix(-1 0 0 1 -1372.33 0)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='.46'
          stopColor='#d45a24'
        />
        <stop
          offset='1'
          stopColor='#a2272d'
        />
      </linearGradient>
      <linearGradient
        id='s-5483b7a313-e'
        x1='-1566.19'
        x2='-1564.61'
        y1='210.63'
        y2='210.63'
        gradientTransform='matrix(-.99 -.11 -.11 .99 -1367.89 -60.26)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='.46'
          stopColor='#f15a24'
        />
        <stop
          offset='1'
          stopColor='#c1272d'
        />
      </linearGradient>
      <linearGradient
        id='s-5483b7a313-ad'
        x1='164.33'
        x2='164.5'
        y1='327.16'
        y2='327.16'
        xlinkHref='#s-5483b7a313-b'
      />
      <linearGradient
        id='s-5483b7a313-ae'
        x1='162.65'
        x2='172.36'
        y1='328.27'
        y2='328.27'
        xlinkHref='#s-5483b7a313-b'
      />
      <clipPath
        id='s-5483b7a313-af'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M953.44 363.63c0 .15 0 .31-.07.48h-.62c0-.17 0-.33.07-.48h.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-ag'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M953.44 363.63h-.62c.06-.41.13-.8.2-1.17h.63c-.08.37-.14.76-.21 1.17z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-ah'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M952.84 364.83h-.11c.09-.69.2-1.37.32-2h.62c-.12.6-.22 1.28-.31 2z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-ai'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954 361a9.65 9.65 0 0 0-.38 1.43H953a10.92 10.92 0 0 1 .39-1.43z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aj'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.33 360.9a5.62 5.62 0 0 0-.66 2h-.62a5.62 5.62 0 0 1 .66-2z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-ak'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954 361h-.62a2.08 2.08 0 0 1 .32-.62h.62a2.35 2.35 0 0 0-.32.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-al'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.35 360.41h-.62a.47.47 0 0 1 .3-.22h.63a.52.52 0 0 0-.31.22z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-am'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.33 360.9h-.62a.48.48 0 0 1 .36-.24h.63a.51.51 0 0 0-.37.24z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-an'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.08 361.1h.62c-.71 0-1.15 2.73-1.4 5.18h-.63c.25-2.45.69-5.18 1.41-5.18z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-ao'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.72 360.18z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-ap'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.7 361.1a.47.47 0 0 1 .28.13h-.63a.43.43 0 0 0-.27-.13z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aq'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.07 360.66h.63a.46.46 0 0 1 .29.14h-.62a.46.46 0 0 0-.3-.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-ar'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.72 360.18a.51.51 0 0 1 .3.14h-.62a.5.5 0 0 0-.31-.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-as'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.71 360a.49.49 0 0 1 .32.15h-.62a.49.49 0 0 0-.32-.15z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-at'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M955 360.32a.87.87 0 0 1 .12.14h-.63a.85.85 0 0 0-.11-.14z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-au'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M955.34 360.66h-.62a1.62 1.62 0 0 0-.31-.55h.59a1.47 1.47 0 0 1 .34.55z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-av'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M955.24 360.65h-.63a1.14 1.14 0 0 0-.1-.19h.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aw'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M955.24 360.65v.07h-.63v-.07h.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-ax'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.35 361.23h.65c.67.61 1.35 5.65 1.55 11.48h-.63c-.21-5.83-.92-10.87-1.57-11.48z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-ay'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M954.37 360.8h.63c.72.63 1.42 5.83 1.62 11.88H956c-.21-6.05-.92-11.25-1.63-11.88z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-az'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M955.43 361.16h-.62a4.1 4.1 0 0 0-.17-.44h.63a4.26 4.26 0 0 1 .16.44z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aA'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M955.53 361.27h-.62c-.06-.23-.13-.44-.19-.61h.62a5 5 0 0 1 .19.61z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aB'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M956 364.19c0 .19.05.39.08.59h-.62c0-.2-.06-.4-.08-.59h.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aC'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M956.24 368.44h-.39c-.1-1.33-.23-2.57-.36-3.66h.62c.14 1.09.26 2.33.36 3.66h-.23z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aD'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M955.53 361.27a23.07 23.07 0 0 1 .53 2.81h-.62a23.07 23.07 0 0 0-.53-2.81z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aE'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M955.43 361.16a21.08 21.08 0 0 1 .6 3h-.62a22.57 22.57 0 0 0-.6-3h.62z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aF'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M956.06 364.08v.19h-.62v-.19z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aG'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M956.44 367.44h-.63c-.1-1.16-.21-2.23-.34-3.17h.62c.13.94.25 2.01.35 3.17z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aH'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M956.62 370.63H956c0-.75-.09-1.48-.14-2.19h.62c.05.71.09 1.44.14 2.19z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aI'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M956.6 369.53h-.6c0-.72-.1-1.42-.16-2.09h.63c.03.67.08 1.37.13 2.09z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aJ'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M956.62 370.63c0 .72.07 1.45.09 2.2h-.62c0-.75-.06-1.48-.1-2.2h.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <clipPath
        id='s-5483b7a313-aK'
        transform='translate(-2.92 -220.08)'
      >
        <path
          d='M956.6 369.53c.06 1.05.12 2.16.16 3.29h-.63c0-1.13-.09-2.24-.16-3.29h.63z'
          style={{
            fill: 'none',
          }}
        />
      </clipPath>
      <linearGradient
        id='s-5483b7a313-aL'
        x1='-107.27'
        x2='-100.32'
        y1='378.59'
        y2='378.59'
        gradientTransform='translate(1054.45)'
        xlinkHref='#s-5483b7a313-d'
      />
      <linearGradient
        id='s-5483b7a313-aM'
        x1='-1269.88'
        x2='-1269.68'
        y1='377.26'
        y2='377.26'
        gradientTransform='matrix(-1 0 0 1 -317.87 0)'
        xlinkHref='#s-5483b7a313-b'
      />
      <linearGradient
        id='s-5483b7a313-aN'
        x1='-1271.82'
        x2='-1260.6'
        y1='378.54'
        y2='378.54'
        gradientTransform='matrix(-1 0 0 1 -317.87 0)'
        xlinkHref='#s-5483b7a313-b'
      />
      <linearGradient
        id='s-5483b7a313-aO'
        x1='-150.27'
        x2='-145.42'
        y1='426.82'
        y2='426.82'
        gradientTransform='rotate(-6.6 2.46 -9135.46)'
        xlinkHref='#s-5483b7a313-e'
      />
      <linearGradient
        id='s-5483b7a313-aP'
        x1='549.49'
        x2='551.49'
        y1='132.5'
        y2='132.5'
        xlinkHref='#s-5483b7a313-c'
      />
      <linearGradient
        id='s-5483b7a313-aQ'
        x1='498.82'
        x2='500.82'
        y1='200.35'
        y2='200.35'
        xlinkHref='#s-5483b7a313-c'
      />
      <linearGradient
        id='s-5483b7a313-aR'
        x1='495.48'
        x2='496.48'
        y1='217.16'
        y2='217.16'
        xlinkHref='#s-5483b7a313-f'
      />
      <linearGradient
        id='s-5483b7a313-aS'
        x1='552.59'
        x2='553.59'
        y1='132.79'
        y2='132.79'
        xlinkHref='#s-5483b7a313-f'
      />
      <linearGradient
        id='s-5483b7a313-aT'
        x1='489.58'
        x2='558.12'
        y1='176.46'
        y2='176.46'
        xlinkHref='#s-5483b7a313-f'
      />
      <linearGradient
        id='s-5483b7a313-aU'
        x1='488.83'
        x2='491.33'
        y1='227.41'
        y2='227.41'
        xlinkHref='#s-5483b7a313-c'
      />
      <linearGradient
        id='s-5483b7a313-aV'
        x1='556.37'
        x2='558.87'
        y1='127.89'
        y2='127.89'
        xlinkHref='#s-5483b7a313-c'
      />
      <linearGradient
        id='s-5483b7a313-g'
        x1='189.07'
        x2='189.07'
        y1='372.15'
        y2='386.87'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#c1272d'
        />
        <stop
          offset='.53'
          stopColor='#c6594b'
        />
        <stop
          offset='1'
          stopColor='#c1272d'
        />
      </linearGradient>
      <linearGradient
        id='s-5483b7a313-aW'
        x1='172.88'
        x2='205.75'
        y1='378.93'
        y2='378.93'
        xlinkHref='#s-5483b7a313-g'
      />
      <linearGradient
        id='s-5483b7a313-aX'
        x1='194.61'
        x2='205.57'
        y1='361.93'
        y2='361.93'
        xlinkHref='#s-5483b7a313-g'
      />
      <linearGradient
        id='s-5483b7a313-aY'
        x1='173.77'
        x2='184.73'
        y1='374.26'
        y2='374.26'
        xlinkHref='#s-5483b7a313-g'
      />
      <linearGradient
        id='s-5483b7a313-aZ'
        x1='183.86'
        x2='206.18'
        y1='368.7'
        y2='368.7'
        xlinkHref='#s-5483b7a313-g'
      />
      <linearGradient
        id='s-5483b7a313-ba'
        x1='184.79'
        x2='206.19'
        y1='369.1'
        y2='369.1'
        xlinkHref='#s-5483b7a313-g'
      />
      <linearGradient
        id='s-5483b7a313-bb'
        x1='-1341.62'
        x2='-1341.62'
        y1='418.59'
        y2='439.05'
        gradientTransform='matrix(-1 0 0 1 -421.87 -220.08)'
        xlinkHref='#s-5483b7a313-g'
      />
      <linearGradient
        id='s-5483b7a313-bc'
        x1='-1349.75'
        x2='-1333.05'
        y1='428.08'
        y2='428.08'
        gradientTransform='matrix(-1 0 0 1 -421.87 -220.08)'
        xlinkHref='#s-5483b7a313-g'
      />
      <linearGradient
        id='s-5483b7a313-bd'
        x1='913.79'
        x2='924.23'
        y1='409.04'
        y2='409.04'
        xlinkHref='#s-5483b7a313-g'
      />
      <linearGradient
        id='s-5483b7a313-be'
        x1='920.31'
        x2='930.47'
        y1='427.65'
        y2='427.65'
        xlinkHref='#s-5483b7a313-g'
      />
      <linearGradient
        id='s-5483b7a313-bf'
        x1='913.63'
        x2='920.63'
        y1='418.8'
        y2='418.8'
        xlinkHref='#s-5483b7a313-g'
      />
    </defs>
    <g
      id='surface'
    >
      <g
        id='mainSurface'
      >
        <path
          d='M1015.65 310.89L1.6 228.7 217.27 99.97l740.23 41.74 58.15 169.18z'
          style={{
            fill: '#4d4d4d',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M989.58 296.39l-951-73 191-114 711 40 49 147z'
          style={{
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M478.81 257.18l86.85-128.88'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <path
        className='tennisLines'
        d='M818.69 255.71l-604.83-44.38 105.51-79.22 496.91 29.81 2.41 93.79z'
      />
      <path
        className='volleyballLines'
        d='M740.42 231.88l-437.87-31.25 62.33-53.92 384.2 23.98-8.66 61.19z'
      />
      <g
        id='surfaceBasket'
        className='basketballTwo'
      >
        <path
          d='M232.04 176.21l-104.27-6.05 38.94-23.25 96.37 6.1-31.04 23.2zM966.68 227.2l-127.33-8.61v-28.08l117.34 6.72 9.99 29.97z'
        />
      </g>
      <path
        id='surfaceBasketAcross'
        d='M588.95 160.65L505 156.41l23.83-30.18 76.64 4.31-16.52 30.11z'
        className='basketballOne'
      />
    </g>
    <g
      id='lines'
    >
      <g
        className='tennisLines'
      >
        <path
          d='M818.69 255.71l-604.83-44.38 105.51-79.22 496.91 29.81 2.41 93.79zM312.13 137.55l504.31 30.87M224 203.72l594.45 42.85M338.54 211.98l71.94-68.41M501.58 223.39l48.21-71.35M705.02 161.6l-18.79 75.44M380.83 171.74l316.44 20.97'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        id='basketballLines'
        className='basketballTwo'
      >
        <ellipse
          cx='253.79'
          cy='384.74'
          rx='38.68'
          ry='11.48'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='rotate(-4.71 -2423.24 310.39)'
        />
        <path
          d='M232.04 176.21l-104.27-6.05 38.94-23.25 96.37 6.1-31.04 23.2z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M207.54 344.36c40.9-2.84 117.63 16.39 83 41.12-58.54 41.76-175.36 37.94-208.45 33.76'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <ellipse
          cx='839.34'
          cy='424.42'
          rx='14'
          ry='40.9'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='rotate(-86 717.524 315.157)'
        />
        <path
          d='M950.49 389.93c-104.72-6.73-153.3 12.22-152.82 31.88.62 25.47 59.25 55.94 184.88 64.31'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M966.68 227.2l-127.33-8.61v-28.08l117.34 6.72 9.99 29.97z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        className='volleyballLines'
      >
        <path
          d='M740.42 231.88l-437.87-31.25 62.33-53.92 384.2 23.98-8.66 61.19zM438.62 210.35l46.67-56.68M506.97 215.22l38.88-57.44M584.62 220.76l28.02-58.58'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <g
        id='basketballAcrossLines'
        className='basketballOne'
      >
        <path
          d='M455.64 342.19C394.2 400.37 688.92 414.41 699 355.88'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M588.95 160.65L505 156.41l23.83-30.18 76.64 4.31-16.52 30.11z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M591.87 380.73c-5.72 7.14-21.21 12.2-41.71 11.87-23.34-.38-45.9-5.87-42.27-16.39'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-2.92 -220.08)'
        />
      </g>
    </g>
    <image
      id='high'
      width='4183'
      height='1282'
      transform='translate(12.92) scale(.24)'
      xlinkHref={_36x181}
    />
    <image
      id='medium'
      width='4058'
      height='1115'
      transform='matrix(.24 0 0 .24 32.84 16.32)'
      xlinkHref={_36x182}
    />
    <image
      id='small'
      width='4104'
      height='1064'
      transform='matrix(.24 0 0 .24 22.28 29.28)'
      xlinkHref={_36x183}
    />
    <g
      id='wicket'
    >
      <path
        d='M249.36 101.56l-18.11-1.03V62.09l18.11 1.06v38.41z'
        style={{
          fill: '#fff',
        }}
      />
      <path
        d='M249.13 73.27l-.85-.07v-3.37l.85.07v3.37zM249.13 94.56l-.85-.07v-3.37l.85.07v3.37z'
        style={{
          fill: '#999',
        }}
      />
      <path
        d='M248.28 64.63v36.32'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-a)',
        }}
      />
      <path
        d='M247.09 64.56v36.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-h)',
        }}
      />
      <path
        d='M245.98 64.5v36.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-i)',
        }}
      />
      <path
        d='M244.87 64.39v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-j)',
        }}
      />
      <path
        d='M243.68 64.32v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-k)',
        }}
      />
      <path
        d='M242.57 64.25v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-l)',
        }}
      />
      <path
        d='M241.45 64.19v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-m)',
        }}
      />
      <path
        d='M240.26 64.11v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-n)',
        }}
      />
      <path
        d='M239.15 64.05v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-o)',
        }}
      />
      <path
        d='M238.04 63.98v36.43'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-p)',
        }}
      />
      <path
        d='M236.85 63.98v36.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-q)',
        }}
      />
      <path
        d='M235.74 63.84v36.39'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-r)',
        }}
      />
      <path
        d='M234.66 63.8v36.33'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-s)',
        }}
      />
      <path
        d='M233.47 63.74v36.39'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-t)',
        }}
      />
      <path
        d='M232.36 63.66v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-u)',
        }}
      />
      <path
        d='M248.28 70.23l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-v)',
        }}
      />
      <path
        d='M248.28 68.78l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-w)',
        }}
      />
      <path
        d='M248.28 67.4l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-x)',
        }}
      />
      <path
        d='M248.28 65.95l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-y)',
        }}
      />
      <path
        d='M248.28 64.57l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-z)',
        }}
      />
      <path
        d='M248.28 99.85l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-A)',
        }}
      />
      <path
        d='M248.28 101.06l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-B)',
        }}
      />
      <path
        d='M248.28 98.47l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-C)',
        }}
      />
      <path
        d='M248.28 97.02l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-D)',
        }}
      />
      <path
        d='M248.28 95.64l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-E)',
        }}
      />
      <path
        d='M248.28 94.19l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-F)',
        }}
      />
      <path
        d='M248.28 92.82l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-G)',
        }}
      />
      <path
        d='M248.28 91.36l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-H)',
        }}
      />
      <path
        d='M248.28 89.99l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-I)',
        }}
      />
      <path
        d='M248.28 88.53l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-J)',
        }}
      />
      <path
        d='M248.28 87.12l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-K)',
        }}
      />
      <path
        d='M248.28 85.67l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-L)',
        }}
      />
      <path
        d='M248.28 84.29l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-M)',
        }}
      />
      <path
        d='M248.28 82.84l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-N)',
        }}
      />
      <path
        d='M248.28 81.46l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-O)',
        }}
      />
      <path
        d='M248.28 80.01l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-P)',
        }}
      />
      <path
        d='M248.28 78.63l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-Q)',
        }}
      />
      <path
        d='M248.28 77.18l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-R)',
        }}
      />
      <path
        d='M248.28 75.8l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-S)',
        }}
      />
      <path
        d='M248.28 74.35l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-T)',
        }}
      />
      <path
        d='M248.28 72.97l-15.92-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-U)',
        }}
      />
      <path
        d='M248.28 71.52l-15.92-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-5483b7a313-V)',
        }}
      />
      <path
        d='M231.25 100.34V62.15l18.11 1.05v38.18'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-5483b7a313-W)',
        }}
      />
      <circle
        cx='234.17'
        cy='78.51'
        r='1.36'
        style={{
          fill: 'url(#s-5483b7a313-X)',
        }}
      />
      <path
        d='M234.17 78.51l3.45.16'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
          stroke: 'url(#s-5483b7a313-Y)',
        }}
      />
    </g>
    <g
      id='basketballAcross'
      className='basketballOne'
    >
      <path
        d='M564.89 128.94l-2.35-.14V78.64l2.35-.01v50.31z'
        style={{
          fill: '#666',
        }}
      />
      <path
        d='M564.89 128.94l1.16-.66V78.25l-1.16.38v50.31z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M566.05 78.25l-1.16.38h-2.99l2.08-.46 2.07.08z'
        style={{
          fill: '#858589',
        }}
      />
      <path
        d='M564.59 96.89l-2.05-.17-3.59-15.92 2.04.17 3.6 15.92z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M564.59 91.7v5.19L561 80.97h-2.27l1.09-1.13h2.08l2.69 11.86z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M577.54 291.62c-1.57-5.32-7.22-9.27-14-9.27s-11.69 2.4-13.26 7.73v6.79l6.55 6.91 13.59.79 7-6.13v-.09z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M570.51 304.67l-13.66-.79-6.6-7V290.03c1.5-5.1 6.11-7.8 13.35-7.8 6.66 0 12.44 3.84 14.06 9.34v6.9zm-13.57-1l13.5.79 7-6.1v-6.75c-1.6-5.41-7.3-9.19-13.87-9.19-7.14 0-11.69 2.65-13.16 7.65v6.73z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M569.85 304l-12.73-.74-6.2-6.55v-6.44c1.41-4.78 5.72-7.32 12.48-7.32 6.22 0 11.62 3.6 13.14 8.75v6.5l-.09.13zm-12.47-1.3l12.28.71L576 298v-6.15c-1.46-4.89-6.63-8.29-12.58-8.29-4.5 0-10.23 1.19-11.92 6.87v6.12z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M561.53 83.56l-2.77-.16v-2.61l2.77.15v2.62z'
        style={{
          fill: '#c1272d',
        }}
      />
      <path
        d='M568.39 301.51l-10.25-.51v-8.49l10.25.57zm-9.56-1.22l8.87.5v-7.11l-8.87-.49z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M563.38 301.91a3.31 3.31 0 0 0-1.29-.28 5 5 0 0 0-1.53.09l1.12-.85 2.77.15z'
        style={{
          fill: '#ea371f',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M562.69 303.16l-6.46.26a.14.14 0 1 1-.09-.27l6.47-.26a.16.16 0 0 1 .18.09.14.14 0 0 1-.1.18z'
        style={{
          fill: 'url(#s-5483b7a313-Z)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M565.66 303.71a.21.21 0 0 1 0 .16c0 .08-.12.08-.19 0l-2.3-.71a.23.23 0 0 1 0-.26c0-.08.12-.08.19 0l2.3.71a.21.21 0 0 1 0 .1z'
        style={{
          fill: 'url(#s-5483b7a313-aa)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M556.63 305.74a5.47 5.47 0 0 1-.16-.7l-.2-.14q.16.44.36.84zM557.4 306c.14.28.28.56.43.82a5.14 5.14 0 0 1-.45-1.3l-.17-.06c.07.14.13.32.19.54zM562.26 308.27c.2-.21.4-.43.58-.66a9.25 9.25 0 0 0-.21-1.17v-.12c-.22.33-.45.64-.68.95.07.23.15.46.23.69zM558.35 304.37c.09.34.17.68.27 1a6.12 6.12 0 0 0 .64.1c0-.74.06-1.49.12-2.23a3.24 3.24 0 0 1 .15-1.18 8.68 8.68 0 0 0-1.81.41 4.29 4.29 0 0 1 .63 1.9zM557.92 306.73a6.64 6.64 0 0 0 .92 1.3c0-.12.08-.23.11-.35l.09-.41c-.14-.36-.27-.72-.38-1.09a4.94 4.94 0 0 1-.27-.42 8.76 8.76 0 0 1-.89-.24 5.1 5.1 0 0 0 .42 1.21zM562.7 306.13a7.08 7.08 0 0 1 .27 1.31v-.06a16.8 16.8 0 0 0 .14-1.73l-.19.05zM560.43 304.61l-.12-1a5.51 5.51 0 0 0-.18-1.15c0-.09-.13-.28-.22-.3s-.25.2-.29.35a4.87 4.87 0 0 0-.09 1c0 .61 0 1.28-.09 2a9.3 9.3 0 0 0 1.07 0c-.02-.27-.05-.58-.08-.9zM560.7 306a2.11 2.11 0 0 0 0 .25 2.6 2.6 0 0 1 .1-.25h-.12zM563.22 307.11a6.59 6.59 0 0 0 .44-.72 5.45 5.45 0 0 0 .06-.9l-.39.12c-.02.5-.05 1-.11 1.5zM562.62 305.91l.11-.18h-.14c.02.09.02.14.03.18zM560.56 306.49v-.53h-.35c.1.16.23.34.35.53zM558.81 306.08l.36.47c0-.22 0-.44.06-.66l-.5-.07c.03.09.05.18.08.26zM559.34 306.78l.35.47.32.42c.14-.26.27-.53.4-.8 0 0 .05-.09.07-.14-.15-.26-.3-.52-.42-.78h-.64c-.02.25-.04.54-.08.83zM560.73 306.56a1.48 1.48 0 0 0 0 .21c.19.33.37.66.55 1l.46-.59c-.15-.41-.29-.82-.4-1.24h-.36c-.07.21-.16.42-.25.62zM563.88 305.81c0-.14.09-.28.13-.42l-.13.05zM561.84 307.05c.24-.32.47-.64.68-1l-.06-.28c-.33.05-.67.1-1 .12.12.4.25.78.38 1.16zM562.55 305.38l.48-.11c.12-.2.24-.42.35-.63a14.65 14.65 0 0 1 .94-2.05 6.84 6.84 0 0 0-1.89-.51v.26c.13 1.01.02 2.03.12 3.04zM565.39 303.67c0-.34-.29-.67-.8-.95a9.08 9.08 0 0 1-.26 2.1c.67-.34 1.07-.76 1.06-1.15zM556.93 306.33c.2.37.42.73.65 1.08v.11c.25.37.51.72.78 1.07l.1.14.16-.37a9.65 9.65 0 0 1-1.06-1.55 7.44 7.44 0 0 1-.62-1.46 2.86 2.86 0 0 1-.35-.18c.14.37.23.76.34 1.16zM556.58 304.63a2.45 2.45 0 0 0 .29.18c-.14-.43-.27-.87-.37-1.31a8.47 8.47 0 0 0 .08 1.13z'
        style={{
          fill: 'none',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M560.67 305.55h.33c.08-.24.16-.48.22-.72.17-.62.26-1.26.45-1.87a4 4 0 0 1 .33-.96h-1.92a4 4 0 0 1 .44 1.79c.06.61.11 1.21.15 1.76zM562.33 303.08a3.73 3.73 0 0 0-.05-.82c-.1-.38-.17-.06-.24.11a3.8 3.8 0 0 0-.18.47c-.18.55-.28 1.12-.42 1.69a9 9 0 0 1-.3 1 11.08 11.08 0 0 0 1.25-.14 19.86 19.86 0 0 1-.06-2.31zM557.3 305a8.63 8.63 0 0 1 0-2.38 3.49 3.49 0 0 0-.78.46c.14.61.31 1.21.5 1.81zM563.49 307.82q.24-.51.45-1a11.37 11.37 0 0 0 .37-1.53h-.1a5.59 5.59 0 0 1-.39 1 10.42 10.42 0 0 1-.33 1.53z'
        style={{
          fill: 'none',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M555.63 85.71z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M564.21 306.45l-.15.49a9.29 9.29 0 0 0 1-2.09 3.16 3.16 0 0 1-.45.28 12 12 0 0 1-.4 1.32zM564.46 302.65a6.8 6.8 0 0 0-.5 1.14 11.24 11.24 0 0 1-.63 1.31l-.06.11a7.06 7.06 0 0 0 .89-.31 8.64 8.64 0 0 0 .3-2.25zM560.21 309l.33-.39-.54-.61c-.08.15-.16.3-.25.45.17.17.31.38.46.55zM563.18 307.4c0 .29-.08.57-.13.85l.21-.21a11.7 11.7 0 0 0 .33-1.26 6 6 0 0 1-.41.62zM562.32 308.43l.15.43.39-.41a.59.59 0 0 1 0-.13v-.5zM557.34 303.9a7.67 7.67 0 0 0 .08 1.17 7 7 0 0 0 1 .29c-.16-.59-.3-1.19-.43-1.78 0-.15-.18-.91-.41-1.05l-.18.07a4.7 4.7 0 0 0 0 .78c-.05.17-.05.35-.06.52zM560.74 307.16v1.26c.15-.18.3-.35.44-.53-.18-.25-.29-.49-.44-.73zM559.93 307.82l-.37-.49-.26-.33-.06.34a8.77 8.77 0 0 0 .46.92c.08-.15.16-.26.23-.44zM556.39 303.25a.88.88 0 0 0-.3.63.84.84 0 0 0 .31.59 7.11 7.11 0 0 1-.01-1.22zM560.57 306.89c-.14.3-.29.59-.45.89l.46.63c.01-.49.01-1.01-.01-1.52zM561.81 308.74l.35-.36c0-.14-.09-.28-.14-.42l-.21-.6-.43.57.12.22zM559.13 306.79l-.17-.22c0 .14.09.27.14.41zM559.6 308.43l-.13-.23c-.1-.19-.2-.39-.29-.6a5.26 5.26 0 0 1-.18.6l.46.48zM558.79 308.17c-.17-.21-.34-.42-.49-.63.15.22.31.45.48.66z'
        style={{
          fill: 'none',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M557.3 305l.12.05a7.67 7.67 0 0 1-.08-1.17v-.52a4.7 4.7 0 0 1 0-.78h-.09a8.63 8.63 0 0 0 .05 2.42zM559.26 305.49h.18c0-.69 0-1.36.09-2a4.87 4.87 0 0 1 .09-1c0-.15.1-.4.29-.35s.18.21.22.3a5.51 5.51 0 0 1 .18 1.15l.12 1c0 .32.06.63.08.94h.16c0-.57-.09-1.15-.17-1.73a4 4 0 0 0-.44-1.79l-.53.05a3.24 3.24 0 0 0-.15 1.18c-.06.76-.07 1.51-.12 2.25zM556.58 304.63a8.47 8.47 0 0 1-.08-1.13c.1.44.23.88.37 1.31a.77.77 0 0 0 .18.1c-.19-.6-.36-1.2-.5-1.81l-.16.15a7.11 7.11 0 0 0 0 1.22 1.45 1.45 0 0 0 .19.16zM557.41 302.17a.2.2 0 0 0-.12.06l.13-.05zM558 303.58c.13.59.27 1.19.43 1.78h.18c-.1-.34-.18-.68-.27-1a4.29 4.29 0 0 0-.63-1.88h-.12c.24.19.41.95.41 1.1z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M564.06 306.94l.15-.49a12 12 0 0 0 .38-1.3l-.29.14a11.37 11.37 0 0 1-.37 1.53q-.21.51-.45 1a10.42 10.42 0 0 0 .33-1.47 5.59 5.59 0 0 0 .39-1l-.2.08c0 .14-.08.28-.13.42v-.37l-.16.05a5.45 5.45 0 0 1-.06.9 6.59 6.59 0 0 1-.44.72c.06-.5.09-1 .11-1.5h-.17a16.8 16.8 0 0 1-.14 1.73v.06a7.08 7.08 0 0 0-.27-1.31l.27-.43-.23.05-.11.18v-.14h-.14l.06.28c-.21.33-.44.65-.68 1-.13-.38-.26-.76-.41-1.13h-.08c.11.42.25.83.4 1.24l-.46.59c-.18-.33-.36-.66-.55-1a1.48 1.48 0 0 1 0-.21c.09-.2.18-.41.26-.61h-.17a2.6 2.6 0 0 0-.1.25 2.11 2.11 0 0 1 0-.25h-.17v.53c-.12-.19-.25-.37-.38-.54h-.12c.12.26.27.52.42.78l-.07.14c-.13.27-.26.54-.4.8l-.32-.42-.35-.47c0-.29.06-.58.08-.87h-.19c0 .22 0 .44-.06.66l-.36-.47c0-.08 0-.17-.08-.26H558.46a4.94 4.94 0 0 0 .27.42c.11.37.24.73.38 1.09l-.09.41c0 .12-.07.23-.11.35a6.64 6.64 0 0 1-.92-1.3 5.1 5.1 0 0 1-.42-1.21h-.12a5.14 5.14 0 0 0 .45 1.3c-.15-.26-.29-.54-.43-.82s-.12-.36-.19-.54l-.2-.09a7.44 7.44 0 0 0 .62 1.46 9.65 9.65 0 0 0 1.06 1.55l-.16.37-.1-.14c-.27-.35-.53-.7-.78-1.07v-.11c-.23-.35-.45-.71-.65-1.08s-.2-.79-.27-1.18a1.18 1.18 0 0 1-.19-.11 5.47 5.47 0 0 0 .16.7q-.2-.4-.36-.84l-.16-.15a10.6 10.6 0 0 0 1.55 3c.11.41.24.81.38 1.2v.66a13.89 13.89 0 0 1-.1 1.71v.39c-.09.45-.33 1.75.29 1.29a.73.73 0 0 0 .34.27.51.51 0 0 0 .54-.17c.15.25.34.49.61.48a.55.55 0 0 0 .38-.28l.1-.14a.69.69 0 0 0 1 .18 1.1 1.1 0 0 0 .3-.34.91.91 0 0 0 .19.2c.37.27.54-.15.61-.45v-.11c.07.12.13.24.19.36s.13 0 .15 0a7.61 7.61 0 0 0 .09-1.91 5.73 5.73 0 0 1 .09-.92v-.06c.06-.3.13-.6.22-.9l.07-.13a11.63 11.63 0 0 0 .58-1.24v-.05a.61.61 0 0 1 .05-.12 12 12 0 0 0 1.46-3l-.23.18a9.29 9.29 0 0 1-1.05 2zm-1.47-.65v.12a9.25 9.25 0 0 1 .21 1.17c-.18.23-.38.45-.58.66l-.12-.34c-.08-.23-.16-.46-.23-.69.27-.28.5-.59.72-.92zm-4.33 3.24c.07.18.15.36.22.53a2.57 2.57 0 0 1-.21.24c0-.22-.07-.45-.1-.68zm-.1 0v-.3a1.19 1.19 0 0 1 .08.2zm.4.7c.07.16.15.32.23.48l-.34.42c-.06-.22-.11-.44-.16-.66zm1.73-.46l-.22-.2zm-.11-.34l.07-.09.42.49-.08.08c-.13-.18-.27-.33-.41-.49zm.23.65l-.46.44-.33-.42.35-.42zm-.39-.81c-.14-.16-.3-.32-.45-.47l.12-.22c.13.2.27.4.42.59zm-.1.12l-.09-.08-.35-.34v-.05zm-.12.13l-.33.39-.33-.41c.08-.12.17-.25.24-.38zm-.43.5l-.48.57-.23-.48a4.66 4.66 0 0 0 .39-.49zm-.48.9c.08.16.17.32.26.47s-.09.11-.13.16l-.29.39a4.44 4.44 0 0 1-.22-.61c.13-.14.25-.28.38-.42zm.18 0l-.07-.13.52-.59.33.42c-.2.2-.4.42-.59.64zm.88-.18l.42.54-.25.31-.39.48-.39-.66c.2-.23.4-.41.66-.67zm.1-.1l.29-.28.18-.18.42.42-.48.57c-.13-.17-.27-.35-.41-.53zm1.64-.58l.39-.43.22.46-.32.45c-.09-.16-.19-.32-.29-.48zm.15.67l-.11.13c-.11-.15-.24-.29-.36-.44l.18-.2c.1.16.2.33.29.51zm-.27-.87l-.28-.41.47-.46.21.41zm-.14.15l-.21.25-.35-.39.3-.28zm-.29.34a.69.69 0 0 1-.11.13l-.06-.07-.28-.39.08-.08zm-.06.4c.12.14.24.29.35.44l-.12.14-.41.48a.41.41 0 0 0-.07-.11l-.27-.39zm.25.06l-.15-.17.1-.12.37.45-.1.12zm.41.28l.27.39-.07.19-.3-.46zm.08-.11l.09-.12.2.36v.11zm.24-.31c.11-.13.21-.27.32-.42v.07l-.2.62zm.14-1.17l.24-.27.15.43-.18.28zm-.11-.23l-.21-.4.33-.33.15.44zm-.28-1.91l.21.6c.05.14.09.28.14.42l-.35.36-.31-.59-.12-.22zm-.48.78l.37.71-.5.47-.34-.49-.09-.13.51-.64a.22.22 0 0 0 .05.08zm-.59-1c.15.24.3.48.44.73-.14.18-.29.35-.44.53q.02-.61 0-1.24zm0 1.75c.12.17.24.35.35.53l-.18.17-.13.12q-.22-.25-.42-.51l.32-.39zm-.61-1.13c.16-.3.31-.59.45-.89v1.54l-.46-.63zm-.13.24l.51.7-.33.39c-.15-.21-.29-.42-.43-.64.12-.2.25-.35.25-.45zm-.73-.95l.26.33.37.49c-.07.15-.15.29-.23.44a8.77 8.77 0 0 1-.46-.92zm-.34-.43l.17.22v.19c-.05-.19-.1-.32-.1-.46zm.22 1c.09.21.19.41.29.6l.13.23-.14.25-.46-.48a5.26 5.26 0 0 0 .21-.62zm-.23.75l.43.47c-.15-.15-.28-.31-.42-.47zm-.65-.81c.15.21.32.42.49.63-.15-.19-.31-.43-.46-.65zm.56 1l.41.43q-.12.19-.24.36l-.35-.43a3 3 0 0 0 .21-.36zm-.25.49l.33.43-.35.46c-.08-.18-.16-.36-.23-.54.12-.11.2-.23.28-.35zm-.76-1l.63.83-.18.36c-.13-.38-.27-.78-.42-1.18zm.31 2.55c.05.22.1.44.17.66l-.26.33c.04-.32.1-.65.12-.98zm-.21 1.65a2.22 2.22 0 0 0 .09.37c-.15-.12-.09-.16-.01-.36zm.3.44a2 2 0 0 1-.16-.57v-.34l.32-.34a6.62 6.62 0 0 0 .24.62l-.28.44a1 1 0 0 1-.09.2zm.12.13c.06-.1.11-.22.16-.31l.17-.27c.07.15.15.31.23.46s.07.13.11.22c-.12.16-.32.21-.64-.09zm.61-.35a3.14 3.14 0 0 1-.18-.37c.11-.16.22-.31.34-.46l.09-.11c.13.22.25.45.38.68l-.3.38-.15.2a2 2 0 0 1-.13-.31zm.71.67c-.33 0-.34 0-.44-.19l.07-.09.38-.48c.13.21.26.42.4.61-.07.16-.07.16-.38.16zm.49-.3l-.24-.43-.11-.19c.21-.26.43-.53.66-.79l.09.13.25.36c-.16.2-.31.4-.45.61a3.28 3.28 0 0 0-.17.32zm1.22 0a.72.72 0 0 1-.9.32.56.56 0 0 1-.2-.18 6.62 6.62 0 0 1 .46-.71l.18-.23.29.45c.06.09.12.21.18.32zm.08-.16a5.44 5.44 0 0 1-.45-.68l.52-.65.33.51c-.1.24-.2.48-.31.72zm.74-.17c0 .13-.05.25-.08.37-.26.12-.44.11-.55 0a5.7 5.7 0 0 0 .37-.9l.27.48a.17.17 0 0 1 .02.09zm0-.33l-.24-.4.06-.17.19.35c.08.1.08.18.07.26zm0-.47l-.15-.27a.36.36 0 0 1 0-.09l.12.23a.53.53 0 0 0 .15.17zm0-.63l.06-.19v.28zm.26 1.64l-.18-.34v-.18a2.16 2.16 0 0 1 .14.43s.15.11.15.13zm0-.3c-.05-.16-.11-.32-.17-.47s0-.09 0-.14l.18.34a2.45 2.45 0 0 1 .14.31zm0-1.62v1l-.15-.38c0-.29 0-.58.08-.88 0 .06.05.11.07.16a.22.22 0 0 1 .16.14zm0-.36l-.06-.14c0-.14.06-.27.1-.41v.09c.2.19.18.35.16.5zm0-1.08c0-.1-.06-.2-.1-.3l.22-.24a5.23 5.23 0 0 1 .08.58zm.13.37v-.07zm.08-1.32l-.39.41-.15-.43.54-.61v.5a.59.59 0 0 0 .2.17zm.25.09v.06a.54.54 0 0 0-.05.11v-.13l.11-.11zm-.06-.29c.05-.28.09-.56.13-.85a6 6 0 0 0 .41-.62 11.7 11.7 0 0 1-.33 1.26z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M561.2 304.83c-.06.24-.14.48-.22.72h.16a9 9 0 0 0 .3-1c.14-.57.24-1.14.42-1.69a3.8 3.8 0 0 1 .18-.47c.07-.17.14-.49.24-.11a3.73 3.73 0 0 1 .05.82 19.86 19.86 0 0 0 .06 2.32h.16c-.1-1 0-2-.09-3v-.26L562 302a4 4 0 0 0-.33.93c-.21.64-.3 1.28-.47 1.9zM563 305.27l.24-.06.06-.11a11.24 11.24 0 0 0 .63-1.31 6.8 6.8 0 0 1 .5-1.14 8.64 8.64 0 0 1-.3 2.25l.17-.08a9.08 9.08 0 0 0 .26-2.1l-.27-.13a14.65 14.65 0 0 0-.94 2.05c-.08.21-.2.43-.35.63zM564.59 302.6a.17.17 0 0 0 .12-.16.17.17 0 0 0-.18-.16.16.16 0 0 0-.16.17.13.13 0 0 0 0 .06l-.06.08.27.13zM559.94 301.91a.13.13 0 0 0 0-.06.2.2 0 1 0-.39 0 .19.19 0 0 0 0 .08.43.43 0 0 0-.09.13 5.42 5.42 0 0 1 .58-.06.41.41 0 0 0-.1-.09zM562.6 301.92a.2.2 0 0 0 0-.15.2.2 0 0 0-.23-.11c-.05 0-.12.06-.12.12a.17.17 0 0 0 0 .1l-.09.12.5.05c-.03-.05-.04-.05-.06-.13zM557.35 302.49a.77.77 0 0 0 0 .15h.09s0-.06.05-.07a.12.12 0 0 1 .13 0h.12a1 1 0 0 0-.15-.14.15.15 0 0 0-.15-.17l-.13.05a.16.16 0 0 0 .04.18zM556.55 303.1v-.05a.1.1 0 0 0 0-.09.14.14 0 0 0-.16-.15.16.16 0 0 0-.16.16.16.16 0 0 0 .15.15v.13z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M557.47 302.53l-.05.07.18-.07a.12.12 0 0 0-.13 0z'
        style={{
          fill: 'url(#s-5483b7a313-b)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M560.69 301.59a9.8 9.8 0 0 0-3.27.59.15.15 0 0 1 .15.17 1 1 0 0 1 .15.14 8.68 8.68 0 0 1 1.81-.41.36.36 0 0 1 .08-.12.14.14 0 0 1 0-.07.18.18 0 0 1 .18-.18.18.18 0 0 1 .18.17.07.07 0 0 1 0 .05.38.38 0 0 1 .12.1h1.92a.39.39 0 0 1 .08-.1.31.31 0 0 1 0-.1.18.18 0 0 1 .12-.12.17.17 0 0 1 .21.1.15.15 0 0 1 0 .13.34.34 0 0 1 0 .14 6.84 6.84 0 0 1 1.89.51l.06-.08a.13.13 0 0 1 0-.06.16.16 0 0 1 .16-.17.17.17 0 0 1 .18.16.17.17 0 0 1-.12.16v.12c.51.28.8.61.8.95s-.38.81-1.06 1.15l-.17.08a7.06 7.06 0 0 1-.89.31l-.24.06-.48.11h-.16a11.08 11.08 0 0 1-1.25.14h-.63a9.3 9.3 0 0 1-1.07 0h-.18a6.12 6.12 0 0 1-.64-.1h-.18a7 7 0 0 1-1-.29l-.12-.05-.25-.11a.77.77 0 0 1-.18-.1 2.45 2.45 0 0 1-.29-.18 1.45 1.45 0 0 1-.18-.16.84.84 0 0 1-.31-.59.88.88 0 0 1 .3-.63v-.13a.16.16 0 0 1-.15-.15.16.16 0 0 1 .16-.16.14.14 0 0 1 .16.15.1.1 0 0 1 0 .09v.05a3.49 3.49 0 0 1 .78-.46.77.77 0 0 1 0-.15.16.16 0 0 1-.06-.26c-1 .42-1.63 1-1.61 1.66a1.21 1.21 0 0 0 .43.86l.16.15.2.14a1.18 1.18 0 0 0 .19.11 2.86 2.86 0 0 0 .35.18l.2.09.17.06h.12a8.76 8.76 0 0 0 .89.24H558.74l.5.07h2.2c.36 0 .7-.07 1-.12h.28l.23-.05.19-.05h.17l.39-.12.16-.05.13-.05.2-.08h.1l.29-.14a3.16 3.16 0 0 0 .45-.28l.23-.18a1.34 1.34 0 0 0 .52-1c-.01-1.3-2.25-2.2-5.09-2.14z'
        style={{
          fill: 'url(#s-5483b7a313-ab)',
        }}
        transform='translate(-2.92 -220.08)'
      />
    </g>
    <g
      id='volleyballNet'
    >
      <path
        d='M550.49 152.64v-40.29'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-5483b7a313-c)',
        }}
      />
      <path
        d='M545.85 133.03l-38.16 51.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M545.85 122.5l-37.53 48.58M545.85 124.26l-37.53 48.55M545.85 125.89l-37.53 48.69M545.85 127.53l-37.53 48.81M545.91 129.03l-37.59 48.93M545.85 130.46l-37.53 49.22M545.77 131.81l-37.45 49.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150000005960464px',
        }}
      />
      <path
        d='M510.32 165.91v15.38M509.65 166.3v15.38M508.82 167.32v15.38M510.97 165.07v15.2M511.66 164.17v15.04M512.37 162.97v15.39M513.01 162.14v15.19M513.71 161.23v15.04M514.46 160.43v15.39M515.11 159.6v15.19M515.81 158.69v15.04M516.51 157.5v15.38M517.15 156.66v15.2M517.85 155.76v15.04M518.57 155.08v15.38M519.22 154.24v15.2M519.92 153.34v15.04M520.62 152.15v15.38M521.26 151.31v15.19M521.96 150.41v15.03M522.6 149.71v15.38M523.25 148.87v15.2M523.95 147.97V163M524.65 146.77v15.39M525.3 145.94v15.19M525.99 145.6v13.9M526.74 144.8v14.25M527.39 143.96v14.06M528.09 143.06v13.9M528.79 141.87v14.24M529.44 141.03v14.06M530.14 140.13v13.9M530.85 139.45v14.25M531.5 138.61v14.06M532.2 137.71v13.9M532.9 136.51v14.25M533.55 135.68v14.06M534.24 134.77v13.9M534.93 133.82v13.9M535.67 133.02v14.25M536.32 132.19v14.06M537.02 131.28v13.9M537.72 130.09v14.25M538.37 129.25v14.06M539.07 128.35v13.9M539.78 127.67v14.25M540.43 126.83v14.06M541.13 125.93v13.9M541.83 124.74v14.24M542.48 123.9v14.06M543.18 122.99v13.91M543.75 122.09v14.25M544.39 121.26v14.06M545.09 120.35v13.91'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150999993085861px',
        }}
      />
      <path
        d='M507.69 168.96l-7.87 9.28M507.82 183.94l-9.43 14.45M507.69 178.77l-7.87 10.82M545.85 119.92l4.76-6.31M545.91 129.03l4.63-5.67M545.91 132.84l4.58-4.97'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
        }}
      />
      <path
        d='M545.85 133.03v-13.11l-38.16 49.04v15.27'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-5483b7a313-f)',
        }}
      />
      <path
        d='M499.82 225.56v-50.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-5483b7a313-ac)',
        }}
      />
    </g>
    <g
      id='basketball'
      className='basketballTwo'
    >
      <path
        d='M150.36 111.64h-2.04l1.41-1.4h1.74l-1.11 1.4z'
      />
      <path
        d='M150.36 157.36l1.11-.68v-46.44l-1.11 1.4v45.72z'
        style={{
          fill: '#666',
        }}
      />
      <path
        d='M150.36 157.36l-2.04-.13v-45.59h2.04v45.72z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M150.36 119.45l1.11-.61 7.44-12.24h-.86l-7.69 12.85z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M150.36 116.8v2.65l7.68-12.85h.87v-2.01l-1.27.16-7.28 12.05z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M160.64 310.72c-3.34.61-6.41 5.66-7.27 10.91l.38 5.86 2.45 5.84 11.37-6.53 1.07-6.59v-4.61c-1.64-3.3-4.27-5.6-8-4.88z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M156.16 333.47l-2.5-6-.39-5.87c.91-5.59 4.14-10.42 7.35-11 4.28-.78 6.77 2.25 8.1 4.93v4.65l-1.07 6.65zm-2.31-6l2.4 5.73 11.23-6.46 1.06-6.54v-4.58c-1.31-2.62-3.73-5.56-7.89-4.81-3.13.58-6.29 5.33-7.19 10.83z'
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M156.59 332.59l-2.36-5.66-.36-5.42c.85-5.23 3.87-9.73 6.88-10.28 4-.74 6.35 2.1 7.6 4.61v4.35l-1 6.21h-.08zm-2-5.72l2.16 5.18 10.25-5.89 1-6V316c-1.2-2.38-3.4-5.06-7.17-4.37-2.86.52-5.75 4.89-6.57 9.93z'
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M157.6 329.33v-7.5l8.16-4.68v7.45zm.79-7.08V328l6.58-3.82v-5.69z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M158.11 109.11l2.27-1.3v-2.04l-2.27 1.28v2.06z'
        style={{
          fill: '#c1272d',
        }}
      />
      <path
        d='M162.78 327.83a2.8 2.8 0 0 1 .85-.67 4.13 4.13 0 0 1 1.16-.49l-1.49-.82-2 1.12z'
        style={{
          fill: '#ea371f',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M162.78 328.27l6-1.64a.12.12 0 0 0 .11-.15.14.14 0 0 0-.16-.11l-6 1.64a.13.13 0 0 0 0 .26z'
        style={{
          fill: 'url(#s-5483b7a313-d)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M163.53 329.44a.15.15 0 0 0 .11 0 .12.12 0 0 0 0-.19l-1.19-1a.13.13 0 1 0-.19.19l1.19 1a.12.12 0 0 0 .08 0z'
        style={{
          fill: 'url(#s-5483b7a313-e)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M163.57 330.08a4.74 4.74 0 0 1-.16-.65l-.19-.13c.11.27.22.53.35.78zM164.31 330.28c.13.26.26.51.41.75a4.75 4.75 0 0 1-.44-1.19l-.15-.06c.06.22.11.33.18.5zM169 332.4c.2-.2.38-.4.56-.61-.05-.37-.12-.72-.2-1.08a.36.36 0 0 1 0-.11q-.32.45-.66.87l.23.63zM165.22 328.82c.08.31.16.63.25.94l.62.09c0-.68.06-1.37.11-2.05a3.09 3.09 0 0 1 .14-1.08 9 9 0 0 0-1.73.37 4 4 0 0 1 .61 1.73zM164.8 331a5.71 5.71 0 0 0 .89 1.18c0-.1.07-.2.1-.31l.09-.38c-.14-.33-.26-.66-.37-1l-.26-.39c-.3-.06-.59-.13-.85-.21a5.09 5.09 0 0 0 .4 1.11zM169.38 330.44a6.73 6.73 0 0 1 .26 1.2l.05-.06c.07-.53.12-1.06.14-1.58h-.19zM167.21 329c0-.3-.07-.6-.12-.9a5.23 5.23 0 0 0-.17-1.05c0-.09-.12-.26-.21-.28s-.24.19-.28.32a4.88 4.88 0 0 0-.09.93c0 .55 0 1.17-.08 1.8.33 0 .67.05 1 .05.01-.25-.02-.54-.05-.87zM167.46 330.27a1.94 1.94 0 0 1 0 .24 2.44 2.44 0 0 0 .1-.24h-.12zM169.88 331.33a4.59 4.59 0 0 0 .42-.66 4.47 4.47 0 0 0 .07-.82l-.37.15c0 .41-.06.87-.12 1.33zM169.31 330.24l.11-.17h-.13s.01.12.02.17zM167.34 330.76v-.49H167c.09.16.22.32.34.49zM165.65 330.39l.35.42c0-.19 0-.4.06-.6-.17 0-.32 0-.48-.06a2.17 2.17 0 0 1 .07.24zM166.16 331c.11.14.22.29.34.43l.3.39c.14-.25.26-.49.39-.73a.91.91 0 0 1 .07-.14 7.24 7.24 0 0 1-.41-.71h-.61c-.02.26-.04.52-.08.76zM167.49 330.83a1.21 1.21 0 0 1 0 .19c.19.3.36.61.53.91l.44-.54c-.14-.38-.27-.76-.38-1.14h-.35c-.07.21-.15.39-.24.58zM170.51 330.14c.05-.13.09-.26.13-.38h-.13a1.93 1.93 0 0 1 0 .38zM168.56 331.27c.23-.29.45-.58.66-.88a2.5 2.5 0 0 1-.07-.26 9.78 9.78 0 0 1-1 .11c.16.34.29.69.41 1.03zM169.24 329.74l.46-.09c.12-.19.23-.39.34-.58a13.09 13.09 0 0 1 .9-1.89 7.28 7.28 0 0 0-1.82-.46 1.2 1.2 0 0 1 0 .24c.13.92.03 1.86.12 2.78zM172 328.17c0-.3-.28-.61-.77-.87a7.25 7.25 0 0 1-.25 1.93c.62-.31 1.02-.69 1.02-1.06zM163.85 330.61c.19.34.4.67.63 1v.1c.24.33.49.66.75 1l.1.12.15-.34a8.88 8.88 0 0 1-1-1.41 6.92 6.92 0 0 1-.59-1.34l-.34-.16c.11.31.2.67.3 1.03zM163.51 329.05l.28.18c-.13-.4-.25-.8-.35-1.21a8.76 8.76 0 0 0 .07 1.03z'
        style={{
          fill: 'none',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M167.44 329.91h.29c.08-.22.16-.44.22-.66.15-.57.25-1.15.43-1.71a3.58 3.58 0 0 1 .31-.85 9.72 9.72 0 0 0-1.23 0 6.08 6.08 0 0 0-.61 0c.35.36.4 1.45.43 1.65.07.5.12 1.03.16 1.57zM169 327.63a2.68 2.68 0 0 0 0-.75c-.1-.35-.16-.05-.23.1s-.12.29-.17.43c-.18.51-.27 1-.4 1.55a9.15 9.15 0 0 1-.29.93 10.59 10.59 0 0 0 1.2-.12 19 19 0 0 1-.11-2.14zM164.21 329.42a7.24 7.24 0 0 1 0-2.18 2.9 2.9 0 0 0-.75.42 15.59 15.59 0 0 0 .48 1.65zM170.14 332c.16-.31.3-.63.43-.94a9.71 9.71 0 0 0 .36-1.41h-.1a5.79 5.79 0 0 1-.37 1 11 11 0 0 1-.32 1.35z'
        style={{
          fill: 'none',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M162.49 110.04z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M170.83 330.72l-.15.46a8.41 8.41 0 0 0 1-1.92 3.48 3.48 0 0 1-.43.25 10.16 10.16 0 0 1-.42 1.21zM171.07 327.24a5.85 5.85 0 0 0-.48 1.05 11.19 11.19 0 0 1-.6 1.2.61.61 0 0 1-.07.1 5.91 5.91 0 0 0 .87-.29 8 8 0 0 0 .28-2.06zM167 333.1l.32-.35c-.17-.22-.33-.44-.5-.65l-.23.42c.13.2.26.39.41.58zM169.84 331.6q0 .39-.12.78l.2-.19c.12-.39.24-.77.32-1.16a4.49 4.49 0 0 1-.4.57zM169 332.54c0 .13.09.26.14.4l.37-.37v-.13-.46c-.14.19-.31.38-.51.56zM164.25 328.39a6.34 6.34 0 0 0 .07 1.07 5.51 5.51 0 0 0 1 .27c-.15-.55-.28-1.1-.42-1.64 0-.13-.17-.83-.38-1l-.17.07a4 4 0 0 0-.06.71c-.03.2-.04.36-.04.52zM167.51 331.38v1.15l.42-.48zM166.73 332l-.36-.46-.24-.3-.06.31a6.2 6.2 0 0 0 .44.85c.07-.15.15-.28.22-.4zM163.33 327.79a.85.85 0 0 0-.29.58.81.81 0 0 0 .3.54 8.39 8.39 0 0 1-.01-1.12zM167.35 331.13l-.44.82.45.58q.01-.69-.01-1.4zM168.53 332.83l.33-.33c0-.13-.08-.26-.13-.38s-.13-.37-.2-.55l-.41.52.11.2zM166 331l-.16-.2.13.37zM166.41 332.55l-.12-.22c-.1-.18-.19-.36-.28-.54 0 .18-.1.37-.17.55l.44.43zM165.64 332.3a6.71 6.71 0 0 1-.48-.58 7.05 7.05 0 0 0 .47.61z'
        style={{
          fill: 'none',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M164.21 329.42h.11a6.34 6.34 0 0 1-.07-1.07v-.48a4 4 0 0 1 .06-.71.25.25 0 0 0-.09 0 7.24 7.24 0 0 0-.01 2.26zM166.09 329.85h.17c0-.63.05-1.25.08-1.8a4.88 4.88 0 0 1 .09-.93c0-.13.1-.37.28-.32s.17.19.21.28a5.23 5.23 0 0 1 .17 1.05c0 .3.08.6.12.9s.06.58.08.87h.15c0-.54-.09-1.07-.16-1.59 0-.2-.08-1.29-.43-1.65l-.51.05a3.09 3.09 0 0 0-.14 1.08c-.05.69-.06 1.38-.11 2.06zM163.51 329.05a8.76 8.76 0 0 1-.07-1c.1.41.22.81.35 1.21l.18.08a15.59 15.59 0 0 1-.48-1.65l-.16.13a8.39 8.39 0 0 0 0 1.12zM164.31 326.81a.13.13 0 0 0-.11.05l.12-.05zM164.88 328.09c.14.54.27 1.09.42 1.64h.17c-.09-.31-.17-.63-.25-.94a4 4 0 0 0-.61-1.73h-.11c.21.2.35.94.38 1.03z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M170.68 331.18l.15-.46a10.16 10.16 0 0 0 .36-1.19l-.28.13a9.71 9.71 0 0 1-.36 1.41c-.13.31-.27.63-.43.94a11 11 0 0 0 .32-1.35 5.79 5.79 0 0 0 .37-1l-.19.08c0 .12-.08.25-.13.38a1.93 1.93 0 0 0 0-.34l-.14.05a4.47 4.47 0 0 1-.07.82 4.59 4.59 0 0 1-.42.66c.06-.46.09-.92.11-1.37h-.16c0 .52-.07 1.05-.14 1.58l-.05.06a6.73 6.73 0 0 0-.26-1.2l.26-.4h-.22l-.11.17v-.13h-.14a2.5 2.5 0 0 0 .07.26c-.21.3-.43.59-.66.88-.12-.34-.25-.69-.39-1h-.08c.11.38.24.76.38 1.14l-.44.54c-.17-.3-.34-.61-.53-.91a1.21 1.21 0 0 0 0-.19c.09-.19.17-.37.25-.56h-.16a2.44 2.44 0 0 1-.1.24 1.94 1.94 0 0 0 0-.24h-.15v.49c-.12-.17-.25-.33-.38-.49h-.11a7.24 7.24 0 0 0 .41.71.91.91 0 0 0-.07.14c-.13.24-.25.48-.39.73l-.3-.39c-.12-.14-.23-.29-.34-.43 0-.27.06-.53.08-.8h-.18c0 .2 0 .41-.06.6l-.35-.42a2.17 2.17 0 0 0-.07-.24h-.32l.26.39c.11.34.23.67.37 1l-.09.38c0 .11-.07.21-.1.31a5.71 5.71 0 0 1-.89-1.18 5.09 5.09 0 0 1-.4-1.11h-.12a4.75 4.75 0 0 0 .44 1.19c-.15-.24-.28-.49-.41-.75s-.12-.33-.18-.5l-.2-.08a6.92 6.92 0 0 0 .59 1.34 8.88 8.88 0 0 0 1 1.41l-.15.34-.1-.12c-.26-.32-.51-.65-.75-1v-.1c-.23-.33-.44-.66-.63-1s-.19-.72-.26-1.07l-.18-.11a4.74 4.74 0 0 0 .16.65 9.22 9.22 0 0 1-.35-.78l-.16-.13a10.24 10.24 0 0 0 1.49 2.78c.11.37.23.74.37 1.1v.6a10.41 10.41 0 0 1-.09 1.57v.35c-.09.41-.32 1.6.27 1.19h.05a.65.65 0 0 0 .33.24.47.47 0 0 0 .51-.15c.14.23.33.45.58.43a.5.5 0 0 0 .37-.25 1.13 1.13 0 0 0 .1-.13.68.68 0 0 0 .93.15 1.19 1.19 0 0 0 .29-.3 1 1 0 0 0 .17.18c.36.25.52-.14.59-.41v-.1l.18.33c0 .05.12 0 .14 0a6.49 6.49 0 0 0 .09-1.76 4.79 4.79 0 0 1 .09-.84v-.06a8.34 8.34 0 0 1 .2-.83l.08-.12a10.68 10.68 0 0 0 .55-1.13.09.09 0 0 0 0-.05v-.11a10.32 10.32 0 0 0 1.4-2.72 1.93 1.93 0 0 1-.21.17 8.41 8.41 0 0 1-.91 1.89zm-1.4-.6a.36.36 0 0 0 0 .11c.08.36.15.71.2 1.08-.18.21-.36.41-.56.61l-.11-.32-.23-.63q.42-.43.7-.85zm-4.16 3c.07.17.15.33.22.49a2.09 2.09 0 0 1-.2.22c0-.2-.07-.41-.1-.62zm-.09 0v-.28c0 .07.05.13.07.19zm.38.64l.22.45c-.11.12-.21.25-.32.38a6 6 0 0 1-.15-.61zm1.66-.42l-.21-.18zm-.1-.31l.07-.08.4.45-.08.07c-.12-.19-.25-.33-.36-.48zm.22.6l-.44.41-.32-.4.34-.38zm-.37-.75l-.44-.43.12-.19c.12.18.26.36.4.53zm-.1.11l-.09-.08-.33-.31zm-.11.13l-.33.35c-.1-.12-.2-.25-.31-.37l.24-.35zm-.42.45c-.15.18-.3.35-.46.52l-.22-.43a4.11 4.11 0 0 0 .38-.45zm-.46.83l.25.43-.12.14-.29.37c-.07-.19-.14-.37-.2-.56zm.17 0l-.06-.12.5-.54.32.38c-.2.19-.39.38-.58.59zm.85-.16c.14.16.27.33.4.49l-.24.28-.37.44c-.13-.2-.25-.4-.37-.6a8.36 8.36 0 0 1 .58-.64zm.1-.1l.27-.26.18-.16c.13.12.27.25.39.38l-.45.53zm1.57-.53l.37-.4.21.43-.3.41zm.14.61l-.11.13-.34-.41.17-.19zm-.26-.79l-.27-.38.46-.42.19.38zm-.13.14l-.2.22-.34-.36.29-.26c.08.09.16.23.25.37zm-.28.31l-.1.12-.07-.07a4.22 4.22 0 0 0-.27-.36l.09-.07zm-.06.36c.12.13.23.27.33.4l-.11.13-.39.44a.61.61 0 0 0-.07-.1c-.08-.12-.17-.24-.26-.35zm.24.06l-.14-.16.1-.11.35.41-.1.11zm.39.25l.26.36a.87.87 0 0 1-.07.17c-.09-.14-.19-.28-.29-.41zm.08-.1l.09-.11.19.34v.1zm.23-.28c.1-.12.21-.25.3-.38-.06.2-.12.39-.19.58zm.13-1.08l.23-.24.15.39-.18.26c-.1-.17-.1-.3-.2-.44zm-.1-.2l-.2-.37.31-.31c.05.14.1.27.14.41zm-.27-1.75c.07.18.14.36.2.55s.09.25.13.38l-.33.33-.3-.54-.11-.2zm-.46.71c.12.22.24.43.35.65l-.47.43-.33-.45-.09-.12c.17-.19.33-.39.49-.59a.56.56 0 0 0 .05.05zm-.56-.9l.42.67-.42.48c.01-.41.01-.79 0-1.18zm0 1.6c.12.16.23.33.34.49l-.17.16-.13.11-.4-.47.31-.36zm-.58-1l.44-.82v1.41l-.45-.58zm-.09.15c.17.21.33.43.5.65l-.32.35c-.15-.19-.28-.38-.41-.58zm-.69-.87l.24.3.36.46c-.07.13-.15.26-.22.4a6.2 6.2 0 0 1-.44-.85zm-.33-.39l.16.2v.17zm.21 1c.09.18.18.36.28.54l.12.22-.13.22-.44-.43c.05-.29.14-.45.14-.66zm-.22.68c.13.15.27.29.41.43-.14-.14-.27-.29-.4-.43zm-.63-.75a6.71 6.71 0 0 0 .48.58 7.05 7.05 0 0 1-.5-.69zm.55.94c.12.14.25.27.38.4l-.22.33c-.12-.13-.23-.27-.34-.4a2.68 2.68 0 0 0 .16-.44zm-.25.45l.32.39c-.1.15-.22.29-.33.43-.08-.17-.15-.33-.22-.5a3.71 3.71 0 0 0 .21-.43zm-.72-.91c.19.26.4.52.6.77-.05.11-.11.22-.17.33-.19-.47-.31-.84-.45-1.21zm.29 2.34c.05.2.1.41.16.61l-.25.3c.04-.41.04-.72.04-1.02zm-.2 1.52a1.59 1.59 0 0 0 .09.33c-.19-.22-.14-.26-.11-.44zm.29.4a1.79 1.79 0 0 1-.15-.52 1.73 1.73 0 0 1 0-.32c.11-.1.21-.2.31-.31.07.2.15.39.23.58-.09.13-.18.26-.26.4s-.12.04-.15.06zm.11.12c.06-.09.1-.2.16-.29s.11-.16.16-.25c.07.15.14.29.22.43l.11.2c-.17.03-.36.07-.67-.2zm.59-.32c-.07-.12-.12-.23-.18-.34l.33-.42.09-.11.36.63c-.1.12-.19.24-.29.35s-.09.13-.14.18a2.75 2.75 0 0 1-.19-.4zm.68.61c-.32 0-.33 0-.43-.17l.07-.08.37-.45a4.58 4.58 0 0 0 .38.56c-.1.04-.09.04-.41.03zm.47-.27c-.09-.14-.17-.3-.23-.4l-.11-.17.63-.72.09.12.25.33a4.71 4.71 0 0 0-.44.56 2.75 2.75 0 0 0-.18.17zm1.17 0a.7.7 0 0 1-.87.3.67.67 0 0 1-.19-.16 5.82 5.82 0 0 1 .44-.66l.17-.21.28.41c.06.09.12.2.18.3zm.08-.14a5.34 5.34 0 0 1-.45-.68c.17-.2.33-.4.5-.59.11.15.21.31.32.47l-.3.65a1 1 0 0 0-.09.06zm.7-.15c0 .11 0 .22-.07.34-.25.11-.43.1-.53 0a5.85 5.85 0 0 0 .36-.82l.25.44a.17.17 0 0 1-.03-.05zm.06-.42l-.23-.37.06-.15a2.58 2.58 0 0 1 .18.32c-.01.08-.01.2-.01.2zm0-.43l-.14-.25v-.08l.12.21a.49.49 0 0 0 .02.14zm0-.58l.06-.18v.27a.36.36 0 0 1-.06-.08zm.25 1.5l-.18-.31v-.16a3 3 0 0 1 .13.39.43.43 0 0 1 .05.1zm0-.27a3.2 3.2 0 0 0-.17-.43.49.49 0 0 0 0-.12l.17.31a1.93 1.93 0 0 1 .04.26zm0-1.48v.93l-.15-.35c0-.27 0-.53.08-.8l.07.14s.05.07.05.1zm0-.33l-.06-.13a2.36 2.36 0 0 1 .1-.38v.08a3 3 0 0 0 .05.45zm0-1c0-.09-.06-.18-.1-.27l.21-.22c.06.18.02.35-.02.51zm.12.35v-.06zm.07-1.21l-.37.37c0-.14-.1-.27-.14-.4.18-.18.35-.37.52-.56v.46zm.25.07v.06l-.05.1v-.12l.1-.1zm-.06-.26q.08-.39.12-.78a4.49 4.49 0 0 0 .4-.57c-.08.39-.2.77-.32 1.16z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M168 329.24c-.06.22-.14.44-.22.66h.16a9.15 9.15 0 0 0 .29-.93c.13-.51.22-1 .4-1.55 0-.14.11-.29.17-.43s.13-.45.23-.1a2.68 2.68 0 0 1 0 .75 19 19 0 0 0 .07 2.14h.15c-.09-.92 0-1.86-.09-2.78a1.2 1.2 0 0 0 0-.24h-.43a3.58 3.58 0 0 0-.31.85c-.22.48-.32 1.06-.42 1.63zM169.7 329.65l.22-.06a.61.61 0 0 0 .07-.1 11.19 11.19 0 0 0 .6-1.2 5.85 5.85 0 0 1 .48-1.05 8 8 0 0 1-.28 2.06l.15-.07a7.25 7.25 0 0 0 .25-1.93l-.25-.12a13.09 13.09 0 0 0-.9 1.89c-.11.19-.22.39-.34.58z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M171.19 327.2a.16.16 0 0 0 .12-.15.17.17 0 0 0-.17-.15.15.15 0 0 0-.16.16v.05l-.05.07.25.12zM166.74 326.58a.18.18 0 0 0-.18-.16.16.16 0 0 0-.16.16.08.08 0 0 0 0 .07.31.31 0 0 0-.09.11l.51-.05a.31.31 0 0 0-.08-.13zM169.08 326.59a.13.13 0 0 0 0-.12.16.16 0 0 0-.2-.09.15.15 0 0 0-.11.11.28.28 0 0 0 0 .09l-.08.1h.43a.65.65 0 0 0-.04-.09zM164.25 327.09v.15a.25.25 0 0 1 .09 0v-.07a.12.12 0 0 1 .13 0h.11a1.49 1.49 0 0 0-.14-.12.15.15 0 0 0-.15-.16l-.12.05a.14.14 0 0 0 .08.15zM163.49 327.66v-.05a.08.08 0 0 0 0-.08.15.15 0 0 0-.15-.15.16.16 0 0 0-.16.15.15.15 0 0 0 .15.14.49.49 0 0 1 0 .12z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M164.37 327.13v.07l.17-.07a.12.12 0 0 0-.17 0z'
        style={{
          fill: 'url(#s-5483b7a313-ad)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M167.45 326.27a9.88 9.88 0 0 0-3.13.54.15.15 0 0 1 .15.16 1.49 1.49 0 0 1 .14.12 9 9 0 0 1 1.73-.37.24.24 0 0 1 .09-.11.08.08 0 0 1 0-.07.16.16 0 0 1 .16-.16.18.18 0 0 1 .18.16.31.31 0 0 1 .11.09 6.08 6.08 0 0 1 .61 0 9.72 9.72 0 0 1 1.23 0l.08-.1a.28.28 0 0 1 0-.09.15.15 0 0 1 .11-.11.16.16 0 0 1 .2.09.13.13 0 0 1 0 .12.65.65 0 0 1 0 .13 7.28 7.28 0 0 1 1.82.46l.05-.07v-.05a.15.15 0 0 1 .16-.16.17.17 0 0 1 .17.15.16.16 0 0 1-.12.15v.1c.49.26.77.57.77.87s-.36.75-1 1.06l-.15.07a5.91 5.91 0 0 1-.87.29l-.22.06-.46.09h-.15a10.59 10.59 0 0 1-1.2.12h-.6c-.36 0-.7 0-1-.05h-.17l-.62-.09h-.17a5.51 5.51 0 0 1-1-.27h-.11l-.24-.11-.18-.08-.28-.18-.17-.14a.81.81 0 0 1-.3-.54.85.85 0 0 1 .29-.58.49.49 0 0 0 0-.12.15.15 0 0 1-.15-.14.16.16 0 0 1 .16-.15.15.15 0 0 1 .15.15.08.08 0 0 1 0 .08v.05a2.9 2.9 0 0 1 .75-.42v-.15a.14.14 0 0 1-.05-.23c-1 .38-1.56.92-1.55 1.52a1.16 1.16 0 0 0 .41.79l.16.13.19.13.18.11.34.16.2.08.15.06h.12c.26.08.55.15.85.21h.32c.16 0 .31.05.48.06H168.18a9.78 9.78 0 0 0 1-.11h.84l.38-.11.14-.05h.13l.19-.08h.1l.28-.13a4.41 4.41 0 0 0 .43-.25 1.93 1.93 0 0 0 .21-.17 1.23 1.23 0 0 0 .51-.92c-.06-1.27-2.22-2.06-4.94-2z'
        style={{
          fill: 'url(#s-5483b7a313-ae)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M961.32 160.29l2.47.01-1.1-1.43-2.66-.04 1.29 1.46z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M961.32 212.87l-1.29-3.93v-50.11l1.29 1.46v52.58z'
        style={{
          fill: '#666',
        }}
      />
      <path
        d='M961.32 212.87l2.47.12V160.3l-2.47-.01v52.58z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M961.32 169.06l-1.29-.71-8.59-14.14h.99l8.89 14.85z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M961.32 165.41v3.65l-8.88-14.85h-1v-2.33l1.68-.12 8.2 13.65z'
        style={{
          fill: '#333',
        }}
      />
      <g
        style={{
          isolation: 'isolate',
        }}
      >
        <path
          d='M949.62 145.8h.62v5.29h-.62z'
        />
        <path
          d='M949.67 146.15h.62v4.93h-.62z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M949.75 146.2h.62v4.84h-.62zM949.62 151.09h.63l.25 7.55h-.62l-.26-7.55z'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-af)',
            }}
          >
            <path
              d='M953 362.75h.62c-.18 1-.32 2.06-.43 3.13h-.62c.11-1.07.25-2.17.43-3.13'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-2.92 -220.08)'
            />
          </g>
        </g>
        <path
          d='M949.66 151.08h.63l.24 7.17h-.63l-.24-7.17z'
          style={{
            fill: '#b4b4b4',
          }}
        />
        <path
          d='M949.75 151.04h.63l.23 6.93h-.63l-.23-6.93z'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-ag)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M953.25 361.53h.62c-.1.36-.19.77-.28 1.22H953c.08-.45.18-.86.28-1.22M953 362.75h.62c-.18 1-.32 2.06-.43 3.13h-.62c.11-1.07.25-2.17.43-3.13'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-ah)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M953.27 362h.62c-.1.35-.19.75-.27 1.18H953c.08-.43.17-.83.27-1.18'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M953 363.13h.62c-.17.92-.31 2-.41 3h-.63c.11-1 .24-2.08.42-3'
                style={{
                  fill: '#a3a3a3',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <path
          d='M950.28 147.56h.62v8.61h-.62z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M950.47 149.1h.62v6.58h-.62z'
          style={{
            fill: '#121212',
          }}
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-ai)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M953.43 361h.62c-.06.16-.12.35-.18.55h-.62a3.55 3.55 0 0 1 .18-.55'
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M953.25 361.53h.62c-.1.36-.19.77-.28 1.22H953c.08-.45.18-.86.28-1.22'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aj)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M953.76 360.84h.62l-.09.12h-.62l.09-.12'
                style={{
                  fill: '#8a8a8a',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M953.67 361h.62c0 .06-.07.11-.1.18h-.62a1 1 0 0 1 .1-.18'
                style={{
                  fill: '#8f8f8f',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M953.57 361.14h.62a2.73 2.73 0 0 0-.13.29h-.62a1.57 1.57 0 0 1 .13-.29'
                style={{
                  fill: '#949494',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M953.44 361.43h.62a4.54 4.54 0 0 0-.17.52h-.62a4.54 4.54 0 0 1 .17-.52'
                style={{
                  fill: '#999',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M953.27 362h.62c-.1.35-.19.75-.27 1.18H953c.08-.43.17-.83.27-1.18'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-ak)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M953.76 360.37h.63a.45.45 0 0 0-.1.13h-.62a.73.73 0 0 1 .09-.13M953.67 360.5h.62a1.42 1.42 0 0 0-.11.18h-.62a.78.78 0 0 1 .11-.18M953.56 360.68h.62c0 .09-.09.19-.13.3h-.62a2.08 2.08 0 0 1 .13-.3M953.43 361h.62c-.06.16-.12.35-.18.55h-.62a3.55 3.55 0 0 1 .18-.55'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-al)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.09 360.18h.63a.44.44 0 0 0-.33.19h-.63a.48.48 0 0 1 .33-.19M953.76 360.37h.63a.45.45 0 0 0-.1.13h-.62a.73.73 0 0 1 .09-.13'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-am)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.07 360.66h.63a.43.43 0 0 0-.32.18h-.62a.41.41 0 0 1 .31-.18'
                style={{
                  fill: '#858585',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M953.76 360.84h.62l-.09.12h-.62l.09-.12'
                style={{
                  fill: '#8a8a8a',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-an)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.08 361.1h.62a.39.39 0 0 0-.29.17h-.63a.39.39 0 0 1 .3-.17'
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M953.78 361.27h.63l-.09.12h-.63l.09-.12M953.69 361.39h.63c0 .05-.07.1-.1.16h-.62l.09-.16M953.6 361.55h.62q-.06.12-.12.27h-.62q.06-.15.12-.27M953.48 361.82h.62c-.05.15-.11.32-.16.5h-.62a4.92 4.92 0 0 1 .16-.5M953.32 362.32h.62c-.09.33-.18.7-.25 1.11h-.63c.08-.41.16-.78.26-1.11M953.06 363.43h.63c-.17.87-.3 1.88-.39 2.85h-.63c.1-1 .23-2 .39-2.85'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-ao)',
            }}
          >
            <path
              d='M954.09 360.18h.63a.44.44 0 0 0-.33.19h-.63a.48.48 0 0 1 .33-.19'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-2.92 -220.08)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-ap)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M951.16 141.02h.62l.01.01h-.62l-.01-.01'
                style={{
                  fill: '#8f8f8f',
                }}
              />
              <path
                d='M954.08 361.1'
                style={{
                  fill: '#949494',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.11 361.11'
                style={{
                  fill: '#999',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.14 361.11'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.17 361.12'
                style={{
                  fill: '#a3a3a3',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.21 361.13h.62-.62'
                style={{
                  fill: '#a8a8a8',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.25 361.15h.62-.62'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.3 361.19H954.98h-.68'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aq)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M951.16 140.58h.63-.63'
              />
              <path
                d='M954.21 360.69h.63-.62M954.26 360.72H954.94h-.63M954.31 360.75h.63v.05h-.62l-.06-.05'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-ar)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M951.17 140.1h.63-.63'
                style={{
                  fill: '#8f8f8f',
                }}
              />
              <path
                d='M954.1 360.18'
                style={{
                  fill: '#949494',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.13 360.19'
                style={{
                  fill: '#999',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.16 360.19'
                style={{
                  fill: '#9e9e9e',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.2 360.2h.62-.62'
                style={{
                  fill: '#a3a3a3',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.24 360.22h.62-.62'
                style={{
                  fill: '#a8a8a8',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.28 360.24H954.96 954.28'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.34 360.28h.72H954.38'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-as)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M951.17 139.88h.63-.63'
              />
              <path
                d='M954.2 360h.62-.62M954.24 360h.62-.62M954.29 360H954.97 954.29M954.35 360.06h.65l.06.05h-.62l-.06-.05'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-at)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.4 360.32h.6-.62'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.44 360.36h.62a2.9 2.9 0 0 1 .44 1h-.63a3.13 3.13 0 0 0-.43-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-au)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.41 360.11h.59-.63M954.44 360.15h.63a2.94 2.94 0 0 1 .45 1.06h-.63a2.77 2.77 0 0 0-.45-1.06'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-av)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.44 360.36h.62a2.9 2.9 0 0 1 .44 1h-.63a3.13 3.13 0 0 0-.43-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aw)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.44 360.36h.62a2.9 2.9 0 0 1 .44 1h-.63a3.13 3.13 0 0 0-.43-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-ax)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.35 361.23h.65-.62'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.39 361.27h.61a2.56 2.56 0 0 1 .4 1h-.62a2.56 2.56 0 0 0-.4-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.79 362.22h.62a23.2 23.2 0 0 1 .59 3.34h-.62a24.69 24.69 0 0 0-.59-3.34'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M955.38 365.56h.62c.25 2 .44 4.49.53 7.15h-.63c-.09-2.66-.28-5.16-.52-7.15'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-ay)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.37 360.8h.63-.62M954.41 360.84h.59a2.72 2.72 0 0 1 .43 1h-.62a2.72 2.72 0 0 0-.43-1M954.84 361.85h.62a26.07 26.07 0 0 1 .62 3.48h-.63a26.35 26.35 0 0 0-.61-3.48'
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M955.45 365.33h.63c.25 2.05.44 4.61.53 7.35H956c-.09-2.74-.29-5.3-.54-7.35'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-az)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.44 360.36h.62a2.9 2.9 0 0 1 .44 1h-.63a3.13 3.13 0 0 0-.43-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aA)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.44 360.15h.63a2.94 2.94 0 0 1 .45 1.06h-.63a2.77 2.77 0 0 0-.45-1.06M954.89 361.21h.63a27.18 27.18 0 0 1 .66 3.76h-.62a28.5 28.5 0 0 0-.67-3.76'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <path
          d='M950.28 156.17h.62l1.92 5.47h-.63l-1.91-5.47z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M950.47 155.68h.62l1.54 4.41h-.62l-1.54-4.41z'
          style={{
            fill: '#131313',
          }}
        />
        <path
          d='M952.01 153.47v6.62l-1.54-4.41v-6.58l1.54 4.37z'
          style={{
            fill: '#d0d0d0',
          }}
        />
        <path
          d='M950.47 149.1h.62l1.54 4.37h-.62l-1.54-4.37z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M952.01 153.46h.62v6.62h-.62z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M950.28 147.56h.62l1.92 5.41h-.63l-1.91-5.41z'
          style={{
            fill: '#131313',
          }}
        />
        <path
          d='M952.19 152.97h.62v8.67h-.62z'
          style={{
            fill: '#121212',
          }}
        />
        <path
          d='M949.88 158.64h.62l2.64 7.47h-.62l-2.64-7.47z'
        />
        <path
          d='M949.9 158.25h.63l2.52 7.16h-.62l-2.53-7.16z'
          style={{
            fill: '#bfbfbf',
          }}
        />
        <path
          d='M949.98 157.97h.63l2.4 6.81h-.63l-2.4-6.81z'
        />
        <path
          d='M952.9 158.8h.62l-.51 5.98h-.63l.52-5.98z'
          style={{
            fill: '#aeaeae',
          }}
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aB)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.87 361.4h.63a27.73 27.73 0 0 1 .64 3.65h-.62a25.9 25.9 0 0 0-.65-3.65'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aC)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.87 361.4h.63a27.73 27.73 0 0 1 .64 3.65h-.62a25.9 25.9 0 0 0-.65-3.65'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M955.52 365.05h.62c.27 2.16.47 4.88.57 7.78h-.62c-.1-2.9-.31-5.62-.57-7.78'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <path
          d='M952.98 158.87h.63l-.56 6.54h-.62l.55-6.54z'
        />
        <path
          d='M952.98 152.63h.63l-.09 6.17h-.62l.08-6.17z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M953.07 152.6h.63l-.09 6.27h-.63l.09-6.27z'
        />
        <path
          d='M954.4 360.32c.74.66 1.48 6.16 1.69 12.51l-.09 6.74-.56 6.62-2.64-7.47-.26-7.55v-5.29c.27-2.7.76-5.7 1.55-5.7a.5.5 0 0 1 .31.14zm1.5 18.62l.09-6.26c-.2-6.05-.91-11.25-1.62-11.88a.46.46 0 0 0-.3-.14c-.76 0-1.22 2.89-1.49 5.47v5l.24 7.17 2.53 7.16.55-6.55'
          style={{
            fill: '#d0d0d0',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M954.35 361.23c.68.61 1.36 5.65 1.55 11.48l-.09 6.17-.51 6-2.4-6.81-.23-6.93v-4.84c.25-2.45.69-5.18 1.41-5.18a.43.43 0 0 1 .27.11zm.76 20.49v-8.67l-1.91-5.41v8.61l1.91 5.47'
          style={{
            fill: '#d0d0d0',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M954.37 360.8c.71.63 1.42 5.83 1.62 11.88l-.09 6.26-.55 6.55-2.51-7.11-.26-7.22v-5c.27-2.58.73-5.47 1.49-5.47a.46.46 0 0 1 .3.11zm1.44 18.08l.09-6.17c-.19-5.83-.87-10.87-1.55-11.48a.43.43 0 0 0-.27-.13c-.72 0-1.16 2.73-1.41 5.18v4.84l.23 6.93 2.4 6.81.51-6'
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M953.2 376.25l1.91 5.47v-8.67l-1.91-5.41zm.18-7.07l1.55 4.36v6.63l-1.55-4.41v-6.58'
          style={{
            fill: '#151515',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aD)',
            }}
          >
            <path
              d='M954.89 361.21h.63a27.18 27.18 0 0 1 .66 3.76h-.62a28.5 28.5 0 0 0-.67-3.76'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-2.92 -220.08)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aE)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.44 360.36h.62a2.9 2.9 0 0 1 .44 1h-.63a3.13 3.13 0 0 0-.43-1'
                style={{
                  fill: '#b8b8b8',
                }}
                transform='translate(-2.92 -220.08)'
              />
              <path
                d='M954.87 361.4h.63a27.73 27.73 0 0 1 .64 3.65h-.62a25.9 25.9 0 0 0-.65-3.65'
                style={{
                  fill: '#b3b3b3',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aF)',
            }}
          >
            <path
              d='M954.89 361.21h.63a27.18 27.18 0 0 1 .66 3.76h-.62a28.5 28.5 0 0 0-.67-3.76'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-2.92 -220.08)'
            />
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aG)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M954.89 361.21h.63a27.18 27.18 0 0 1 .66 3.76h-.62a28.5 28.5 0 0 0-.67-3.76M955.56 365h.62c.27 2.19.48 4.93.58 7.85h-.63c-.09-2.92-.3-5.66-.57-7.85'
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aH)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M955.52 365.05h.62c.27 2.16.47 4.88.57 7.78h-.62c-.1-2.9-.31-5.62-.57-7.78'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aI)',
            }}
          >
            <path
              d='M955.56 365h.62c.27 2.19.48 4.93.58 7.85h-.63c-.09-2.92-.3-5.66-.57-7.85'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-2.92 -220.08)'
            />
          </g>
        </g>
        <path
          d='M953.08 159.49h.63l-.57 6.62h-.62l.56-6.62z'
          style={{
            fill: '#aeaeae',
          }}
        />
        <path
          d='M953.13 159.52h.62l-.59 6.91h-.63l.6-6.91z'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aJ)',
            }}
          >
            <g
              style={{
                isolation: 'isolate',
              }}
            >
              <path
                d='M955.52 365.05h.62c.27 2.16.47 4.88.57 7.78h-.62c-.1-2.9-.31-5.62-.57-7.78'
                style={{
                  fill: '#adadad',
                }}
                transform='translate(-2.92 -220.08)'
              />
            </g>
          </g>
        </g>
        <path
          d='M953.17 152.75h.62l-.08 6.74h-.63l.09-6.74z'
          style={{
            fill: '#b2b2b2',
          }}
        />
        <path
          d='M953.21 152.75h.63l-.09 6.77h-.62l.08-6.77z'
        />
        <g
          style={{
            isolation: 'isolate',
          }}
        >
          <g
            style={{
              clipPath: 'url(#s-5483b7a313-aK)',
            }}
          >
            <path
              d='M955.56 365h.62c.27 2.19.48 4.93.58 7.85h-.63c-.09-2.92-.3-5.66-.57-7.85'
              style={{
                isolation: 'isolate',
              }}
              transform='translate(-2.92 -220.08)'
            />
          </g>
        </g>
        <path
          d='M954.41 360.11c.74.67 1.51 6.25 1.72 12.71l-.13 6.78-.59 6.9-2.69-7.61-.26-7.7v-5.34c.28-2.81.78-5.89 1.59-5.89a.49.49 0 0 1 .36.15zm1.59 19.46l.09-6.74c-.21-6.35-1-11.85-1.69-12.51a.5.5 0 0 0-.31-.14c-.79 0-1.28 3-1.55 5.7v5.29l.26 7.55 2.64 7.47.56-6.62'
          transform='translate(-2.92 -220.08)'
        />
      </g>
      <path
        d='M951.69 161.93l-.62-1.72.1-2.84.55 1.29-.03 3.27z'
        style={{
          fill: '#c1272d',
        }}
      />
      <path
        d='M953.67 378.81a.59.59 0 0 0-.17-1c-.77-.45-1-.34-1-.34h1.58l.55 1.29z'
        style={{
          fill: '#ea371f',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M954 380.77l-6.63-4.07a.15.15 0 0 1-.13-.17.16.16 0 0 1 .18-.13l6.64 4.07a.17.17 0 0 1 .13.18.16.16 0 0 1-.19.12z'
        style={{
          fill: 'url(#s-5483b7a313-aL)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M952.89 380.64a4.94 4.94 0 0 0 .18-.76 1.64 1.64 0 0 0 .22-.14c-.12.26-.29.6-.4.9zM952 380.87c-.15.29-.3.58-.47.87a5.15 5.15 0 0 0 .5-1.39l.18-.06c-.03.19-.1.38-.21.58zM946.65 383.31c-.22-.22-.43-.46-.64-.7a8.73 8.73 0 0 1 .23-1.24v-.12c.24.34.5.67.76 1-.09.25-.17.49-.26.73zM951 379.17c-.09.37-.19.73-.29 1.09l-.72.11c-.05-.79-.06-1.58-.12-2.37a3.43 3.43 0 0 0-.17-1.25 9.92 9.92 0 0 1 2 .43 4.51 4.51 0 0 0-.7 1.99zM951.46 381.68a6.26 6.26 0 0 1-1 1.37c0-.11-.08-.24-.12-.36s-.07-.29-.1-.44a11.43 11.43 0 0 0 .42-1.16 4.27 4.27 0 0 0 .3-.44 7.94 7.94 0 0 0 1-.25 5.06 5.06 0 0 1-.5 1.28zM946.17 381.05a7.8 7.8 0 0 0-.3 1.39l-.06-.08c-.08-.6-.13-1.21-.15-1.82h.21zM948.68 379.43c0-.34.09-.69.14-1a4.94 4.94 0 0 1 .2-1.21c0-.1.14-.3.24-.33s.27.22.32.38a4.79 4.79 0 0 1 .1 1.07c.05.64.06 1.36.09 2.08a11 11 0 0 1-1.18.05zM948.39 380.86a2.45 2.45 0 0 0 0 .27l-.12-.27h.14zM945.59 382.08a8.9 8.9 0 0 1-.49-.76 7.45 7.45 0 0 1-.07-.95l.44.12q.03.8.12 1.59zM946.25 380.82l-.12-.19h.15zM948.54 381.43v-.57h.46a6 6 0 0 0-.46.57zM950.48 381c-.14.16-.27.33-.4.49 0-.23-.05-.46-.07-.69l.55-.07c-.03.08-.05.17-.08.27zM949.89 381.73c-.13.17-.25.34-.38.5l-.36.45-.44-.85a1.09 1.09 0 0 1-.08-.15c.17-.27.32-.55.47-.83h.7c.02.27.05.57.09.88zM948.35 381.5v.22c-.21.35-.41.7-.61 1l-.51-.62c.16-.44.32-.88.45-1.32h.39c.08.29.18.51.28.72zM944.87 380.7c-.06-.14-.11-.29-.16-.44l.15.05c0 .13 0 .26.01.39zM947.12 382c-.26-.34-.52-.68-.76-1 0-.1 0-.2.07-.3a10.45 10.45 0 0 0 1.14.13c-.16.39-.31.78-.45 1.17zM946.33 380.24l-.53-.1-.39-.68a14.89 14.89 0 0 0-1-2.17 7.79 7.79 0 0 1 2.1-.54 1.58 1.58 0 0 0 0 .28c-.19 1.07-.07 2.15-.18 3.21zM943.19 378.43c0-.35.33-.7.89-1a8.61 8.61 0 0 0 .29 2.22c-.76-.36-1.19-.8-1.18-1.22zM952.56 381.25c-.22.39-.46.78-.72 1.15h-.06v.12c-.27.39-.56.76-.86 1.14l-.12.14-.18-.39a9.86 9.86 0 0 0 1.18-1.64 8.11 8.11 0 0 0 .68-1.54l.39-.19c-.09.38-.19.79-.31 1.21zM953 379.45a2.49 2.49 0 0 1-.32.2c.15-.46.29-.92.4-1.39a7.84 7.84 0 0 1-.08 1.19z'
        style={{
          fill: 'none',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M948.42 380.43h-.34a6.75 6.75 0 0 1-.25-.76c-.18-.65-.29-1.33-.5-2a3.86 3.86 0 0 0-.36-1 13 13 0 0 1 1.42 0h.7a4.18 4.18 0 0 0-.49 1.91q-.12.94-.18 1.85zM946.58 377.81a4.2 4.2 0 0 1 0-.87c.12-.4.19-.06.27.12s.14.32.2.49c.2.59.31 1.2.46 1.8a10.16 10.16 0 0 0 .33 1.07q-.74 0-1.38-.15a20 20 0 0 0 .12-2.46zM952.15 379.87a8.87 8.87 0 0 0 0-2.52 3.61 3.61 0 0 1 .86.49c-.15.64-.34 1.28-.55 1.91zM945.3 382.84c-.19-.36-.35-.72-.51-1.09a12.39 12.39 0 0 1-.41-1.62l.12.05a5.59 5.59 0 0 0 .43 1.1 10.71 10.71 0 0 0 .37 1.56z'
        style={{
          fill: 'none',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M947.85 160.6z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M944.5 381.38c0 .17.11.35.17.52a9.54 9.54 0 0 1-1.11-2.21 4.7 4.7 0 0 0 .5.29 11 11 0 0 0 .44 1.4zM944.22 377.36a5.92 5.92 0 0 1 .55 1.2 12 12 0 0 0 .7 1.39l.07.12a8.19 8.19 0 0 1-1-.33 8.82 8.82 0 0 1-.32-2.38zM948.92 384.13l-.36-.41.57-.75.27.48c-.15.23-.31.46-.48.68zM945.63 382.39c0 .3.09.61.15.91l-.24-.23c-.13-.44-.26-.89-.36-1.34a7.66 7.66 0 0 0 .45.66zM946.59 383.48c-.05.15-.11.3-.17.46l-.42-.43v-.15-.53c.18.22.38.44.59.65zM952.1 378.68a7.31 7.31 0 0 1-.08 1.24 7.33 7.33 0 0 1-1.13.31c.17-.63.32-1.26.48-1.89 0-.16.2-1 .44-1.11l.2.08a3.58 3.58 0 0 1 .06.82 5.07 5.07 0 0 1 .03.55zM948.33 382.14v1.33l-.49-.56zM949.23 382.84l.42-.53.28-.34c0 .12 0 .24.07.36a8.12 8.12 0 0 1-.51 1zM953.16 378a.93.93 0 0 1 .33.67.91.91 0 0 1-.34.63 8.08 8.08 0 0 0 .01-1.3zM948.52 381.85c.16.31.33.63.51.94l-.52.67c0-.52 0-1.07.01-1.61zM947.16 383.81l-.39-.38.15-.44c.08-.21.15-.42.23-.64l.48.6c0 .08-.08.16-.13.24zM950.12 381.74a2.11 2.11 0 0 0 .19-.23c0 .14-.1.29-.16.43zM949.6 383.48c0-.08.1-.16.14-.24a6.23 6.23 0 0 0 .32-.63 6.6 6.6 0 0 0 .2.63c-.16.17-.33.34-.5.5a2.26 2.26 0 0 1-.16-.26zM950.5 383.21c.19-.22.37-.44.54-.67a8.58 8.58 0 0 1-.53.7z'
        style={{
          fill: 'none',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M952.15 379.87l-.13.05a7.31 7.31 0 0 0 .08-1.24 5.07 5.07 0 0 0 0-.55 3.58 3.58 0 0 0-.06-.82h.11a8.87 8.87 0 0 1 0 2.56zM950 380.37h-.2c0-.72 0-1.44-.09-2.08a4.79 4.79 0 0 0-.1-1.07c-.05-.16-.11-.43-.32-.38s-.2.23-.24.33a4.94 4.94 0 0 0-.2 1.21c-.05.35-.1.7-.14 1l-.09 1h-.17q.06-.92.18-1.83a4.18 4.18 0 0 1 .49-1.91l.59.06a3.43 3.43 0 0 1 .17 1.25c.03.84.04 1.63.12 2.42zM953 379.45a7.84 7.84 0 0 0 .08-1.19c-.11.47-.25.93-.4 1.39l-.2.1c.21-.63.4-1.27.55-1.91l.18.15a8.08 8.08 0 0 1 0 1.3zM952 376.85a.18.18 0 0 1 .13.06l-.14-.06zM951.37 378.34c-.16.63-.31 1.26-.48 1.89h-.2c.1-.36.2-.72.29-1.09a4.51 4.51 0 0 1 .71-2l.12.05c-.24.19-.4.99-.44 1.15z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M943.56 379.69l-.25-.2a12.31 12.31 0 0 0 1.62 3.14l.06.13v.05a14.38 14.38 0 0 0 .64 1.31l.09.14c.09.31.18.63.24 1a.06.06 0 0 0 0 .07 5.32 5.32 0 0 1 .1 1 7.26 7.26 0 0 0 .11 2 .09.09 0 0 0 .16 0l.21-.38a.36.36 0 0 0 0 .11c.08.32.27.77.68.48a.67.67 0 0 0 .2-.21 1.47 1.47 0 0 0 .34.36.78.78 0 0 0 1.06-.19l.1.15a.58.58 0 0 0 .43.3c.29 0 .51-.25.67-.51a.59.59 0 0 0 .6.18.79.79 0 0 0 .38-.28c.69.48.42-.89.32-1.36a3 3 0 0 0 0-.42 13.74 13.74 0 0 1-.11-1.81 5.3 5.3 0 0 0 0-.69c.16-.42.3-.84.43-1.27a11.38 11.38 0 0 0 1.72-3.22l-.18.16c-.12.3-.25.6-.4.9a4.94 4.94 0 0 0 .18-.76l-.21.13c-.08.41-.18.82-.3 1.24s-.46.78-.72 1.15h-.06v.12c-.27.39-.56.76-.86 1.14l-.12.14-.18-.39a9.86 9.86 0 0 0 1.18-1.64 8.11 8.11 0 0 0 .68-1.54l-.23.09c-.06.19-.13.38-.21.58s-.3.58-.47.87a5.15 5.15 0 0 0 .5-1.39h-.13a5.06 5.06 0 0 1-.47 1.28 6.26 6.26 0 0 1-1 1.37c0-.11-.08-.24-.12-.36s-.07-.29-.1-.44a11.43 11.43 0 0 0 .42-1.16 4.27 4.27 0 0 0 .3-.44h-.38c0 .09 0 .18-.08.27s-.27.33-.4.49c0-.23-.05-.46-.07-.69h-.21c0 .31.05.61.09.92-.13.17-.25.34-.38.5l-.36.45-.44-.85a1.09 1.09 0 0 1-.08-.15c.17-.27.32-.55.47-.83H949a6 6 0 0 0-.42.57v-.57h-.18a2.45 2.45 0 0 0 0 .27l-.12-.27h-.19c.09.22.19.44.29.65s0 .15 0 .22c-.21.35-.41.7-.61 1l-.51-.62c.16-.44.32-.88.45-1.32h-.1c-.16.4-.31.79-.45 1.2-.26-.34-.52-.68-.76-1 0-.1 0-.2.07-.3h-.15v.15l-.12-.19-.26-.06.3.47a7.8 7.8 0 0 0-.3 1.39l-.06-.08c-.08-.6-.13-1.21-.15-1.82l-.19-.05q0 .79.12 1.59a8.9 8.9 0 0 1-.49-.76 7.45 7.45 0 0 1-.07-.95l-.17-.06v.39c-.06-.14-.11-.29-.16-.44l-.21-.08a5.59 5.59 0 0 0 .43 1.1 10.71 10.71 0 0 0 .37 1.56c-.19-.36-.35-.72-.51-1.09a12.39 12.39 0 0 1-.41-1.62l-.32-.15a11 11 0 0 0 .42 1.38c0 .17.11.35.17.52a9.54 9.54 0 0 1-1.15-2.07zm3.49 2.53c-.09.25-.17.49-.26.73l-.14.36c-.22-.22-.43-.46-.64-.7a8.73 8.73 0 0 1 .23-1.24v-.12c.29.31.55.64.81.97zm4.13 2.53c0 .24-.06.48-.1.72a2.77 2.77 0 0 1-.24-.25l.25-.57zm0-.22l.09-.21v.32zm-.09 1.1c0 .24-.11.47-.17.7l-.38-.44c.09-.17.18-.34.26-.51zm-2-1l-.24.21zm-.57.38l-.09-.08c.16-.17.32-.34.47-.52l.08.09zm.69-.24l.39.44-.37.45-.51-.47zm-.15-.55c.16-.2.32-.4.46-.61a2.53 2.53 0 0 1 .13.22l-.5.5zm.69-.23c-.12.12-.25.25-.38.36l-.1.09zm.11.18l.27.41-.36.43-.37-.41zm.37.54a4.15 4.15 0 0 0 .43.51l-.25.51-.54-.6zm.6 1.81c-.07.22-.15.43-.24.65a3.39 3.39 0 0 0-.33-.42 2.09 2.09 0 0 0-.14-.17c.1-.16.19-.33.29-.5zm-.83-.07c-.21-.23-.43-.46-.66-.68.12-.15.24-.3.37-.44.19.21.38.42.58.62l-.08.14zm-.09.16c-.14.24-.29.47-.43.7l-.43-.51-.28-.32c.15-.19.3-.39.46-.58.21.26.44.5.66.74zm-1.24-.25l-.53-.61.46-.45.2.19c.11.1.22.2.32.31zm-1.69-.67c-.12-.16-.24-.31-.35-.47l.25-.5.42.46zm.48-.34a2.09 2.09 0 0 1 .2.22c-.14.15-.27.3-.4.46l-.12-.14c.09-.15.19-.34.3-.51zm-.46-.86l.22-.45.53.49-.3.44zm.89.17l.33.3-.38.42c-.07-.09-.15-.17-.23-.26zm.43.39l.1.09c-.11.13-.21.27-.31.41l-.08.08a1.34 1.34 0 0 1-.11-.14zm.22 1.48l-.31.41-.07.11c-.15-.17-.3-.34-.46-.5l-.12-.15c.12-.16.25-.32.38-.47zm-1.08-.26l-.11-.13c.13-.16.27-.31.41-.47l.11.13-.16.18a3.47 3.47 0 0 0-.27.32zm-.09.13l-.34.48c0-.06 0-.13-.08-.19l.3-.42zm-.48.13v-.12c.08-.12.15-.25.22-.38a1.47 1.47 0 0 1 .1.13zm-.15-.41c-.08-.22-.16-.45-.23-.67v-.06c.11.15.23.3.35.44zm-.23-1.07c-.07-.09-.13-.19-.2-.29l.17-.45.26.28c-.1.18-.17.34-.25.49zm.06-1l.16-.46c.12.12.24.24.37.35l-.23.43zm1.08-1.11c0 .08-.08.16-.13.24l-.34.62-.39-.38.15-.44c.08-.21.15-.42.23-.64zm.11.14l.57.68-.1.13c-.13.18-.26.35-.38.53l-.55-.5c.13-.25.27-.5.41-.75zm.6.38l-.49-.56.48-.77c-.02.45-.02.87-.01 1.34zm.08.43l.35.42-.46.55-.15-.14-.2-.18.39-.56zm.62-1.09l-.52.67v-1.63c.16.31.33.63.51.94zm.36.64c-.15.23-.31.46-.48.68l-.36-.41.57-.75zm.6-1.12a8.12 8.12 0 0 1-.51 1l-.26-.46.42-.53.28-.34c.05.1.05.22.05.34zm.15-.39v-.2a2.11 2.11 0 0 0 .19-.23c-.1.15-.15.3-.21.44zm.11 1.3c-.16.17-.33.34-.5.5a2.26 2.26 0 0 1-.16-.26c0-.08.1-.16.14-.24a6.23 6.23 0 0 0 .32-.63 6.6 6.6 0 0 0 .18.64zm.08.2c-.15.17-.3.34-.46.5v-.05c.16-.16.32-.32.47-.49zm.17-.2c.19-.22.37-.44.54-.67a8.58 8.58 0 0 1-.56.68zm.11.76l-.39.46c-.09-.12-.17-.25-.26-.38l.45-.46a3.48 3.48 0 0 0 .18.39zm.35.51c-.08.19-.16.38-.25.57a6 6 0 0 1-.39-.49l.37-.45zm.07-.16c-.07-.12-.14-.25-.2-.38.24-.29.47-.58.7-.88-.18.43-.35.86-.56 1.27zm.26 2.5l-.29-.36c.07-.23.14-.46.19-.7 0 .36.06.72.08 1.07zm0 1.07a1.27 1.27 0 0 0 .11-.38c.03.23.09.27-.11.39zm-.34-.11a4.53 4.53 0 0 0-.3-.46 5.46 5.46 0 0 0 .26-.67l.36.36a2.31 2.31 0 0 1 0 .37 1.72 1.72 0 0 1-.18.6 2.19 2.19 0 0 1-.12-.19zm-.76.44c0-.09.09-.17.12-.23l.26-.49.19.29c.06.09.11.22.18.33-.36.32-.58.27-.75.11zm-.13-.13l-.16-.21-.34-.41.42-.72.1.12c.13.15.26.31.38.48-.06.13-.13.26-.2.39a4 4 0 0 1-.2.36zm-1 .2a7.23 7.23 0 0 0 .44-.64l.43.51.07.09c-.11.19-.12.2-.49.2s-.4.02-.49-.15zm-.31-.48c-.16-.22-.33-.43-.51-.64l.29-.39.1-.13c.25.27.49.55.73.83l-.12.2c-.08.12-.17.29-.27.46-.11-.1-.18-.16-.26-.32zm-1.14.33c.07-.12.13-.24.2-.34l.32-.48.2.24c.19.24.34.51.51.76a.77.77 0 0 1-.22.19.82.82 0 0 1-1-.34zm-.17-.31c-.12-.25-.23-.5-.34-.76l.37-.54.57.69a7 7 0 0 1-.51.78zm-.74-.08q.13-.25.3-.51a5.56 5.56 0 0 0 .41 1c-.12.14-.32.16-.61 0a2.74 2.74 0 0 1-.09-.39.25.25 0 0 1-.05-.09zm-.07-.53l.21-.37c0 .06 0 .11.07.17l-.26.43zm0-.39l.14-.24a.42.42 0 0 0 0 .1 2.61 2.61 0 0 0-.17.28.66.66 0 0 0-.04-.13zm0-.43v-.3l.08.2a.47.47 0 0 0-.17.11zm-.26 1.58a3.57 3.57 0 0 1 .16-.46v.19l-.21.36a.13.13 0 0 0-.04-.09zm0-.54l.2-.36a.76.76 0 0 0 0 .15 4.14 4.14 0 0 0-.19.49 2.46 2.46 0 0 1-.15-.27zm0-1.52a1.19 1.19 0 0 1 .08-.16q.06.46.09.93c-.06.13-.12.26-.17.4v-1.08zm-.12-.78a.42.42 0 0 1 0-.1c0 .15.08.29.11.44a1 1 0 0 1-.07.15c-.12-.16-.15-.32-.18-.48zm0-1.23l.24.26c0 .1-.07.2-.11.31-.24-.18-.28-.37-.32-.56zm0 .81v.13zm-.08-1.39v-.53c.19.22.39.44.6.65-.05.15-.11.3-.17.46l-.42-.43zm-.28.16l.11.12v.14l-.06-.12v-.06zm-.15-.45c-.13-.44-.26-.89-.36-1.34a7.66 7.66 0 0 0 .45.66c0 .3.09.61.15.91z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M947.83 379.66a6.75 6.75 0 0 0 .25.76h-.19a10.16 10.16 0 0 1-.33-1.07c-.15-.6-.26-1.21-.46-1.8-.06-.17-.13-.33-.2-.49s-.15-.52-.27-.12a4.2 4.2 0 0 0 0 .87 20 20 0 0 1-.07 2.46h-.18c.11-1.06 0-2.14.11-3.21a1.58 1.58 0 0 1 0-.28l.5-.05a3.86 3.86 0 0 1 .36 1c.19.6.3 1.27.48 1.93zM945.8 380.14l-.26-.07-.07-.12a12 12 0 0 1-.7-1.39 5.92 5.92 0 0 0-.55-1.2 8.82 8.82 0 0 0 .33 2.38l-.18-.09a8.61 8.61 0 0 1-.29-2.22l.29-.14a14.89 14.89 0 0 1 1 2.17zM944.08 377.3a.16.16 0 0 1-.13-.17.19.19 0 0 1 .37 0 .13.13 0 0 1 0 .06l.06.09-.29.14zM949.22 376.59a.2.2 0 0 1 .39 0 .24.24 0 0 1 0 .08.38.38 0 0 1 .09.12l-.59-.06zM946.52 376.61a.19.19 0 0 1 .23-.25.2.2 0 0 1 .13.12.34.34 0 0 1 0 .1l.09.11-.5.05a.58.58 0 0 1 .05-.13zM952.1 377.18a1 1 0 0 0 0 .17h-.11a.26.26 0 0 0 0-.09.15.15 0 0 0-.16 0l-.12-.05a1.07 1.07 0 0 1 .16-.14.17.17 0 0 1 .17-.19l.14.06a.17.17 0 0 1-.08.24zM953 377.84v-.06a.17.17 0 0 1 0-.1.19.19 0 0 1 .19-.16.17.17 0 0 1 .17.17.17.17 0 0 1-.17.16.71.71 0 0 1 0 .14z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M952 377.22a.26.26 0 0 1 0 .09l-.2-.08a.15.15 0 0 1 .2-.01z'
        style={{
          fill: 'url(#s-5483b7a313-aM)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M948.4 376.23a11.26 11.26 0 0 1 3.62.62.17.17 0 0 0-.17.19 1.07 1.07 0 0 0-.16.14 9.92 9.92 0 0 0-2-.43.38.38 0 0 0-.09-.12.24.24 0 0 0 0-.08.2.2 0 0 0-.39 0l-.13.1h-.7a13 13 0 0 0-1.42 0l-.09-.11a.34.34 0 0 0 0-.1.2.2 0 0 0-.13-.12.19.19 0 0 0-.23.25.58.58 0 0 0 0 .14 7.79 7.79 0 0 0-2.1.54l-.06-.09a.13.13 0 0 0 0-.06.19.19 0 0 0-.37 0 .16.16 0 0 0 .13.17v.13c-.56.3-.89.65-.89 1s.42.86 1.18 1.22l.18.09a8.19 8.19 0 0 0 1 .33l.26.07.53.1h.18q.65.11 1.38.15h.7a11 11 0 0 0 1.18-.05h.2l.72-.11h.2a7.33 7.33 0 0 0 1.13-.31l.13-.05.28-.12.2-.1a2.49 2.49 0 0 0 .32-.2l.2-.16a.91.91 0 0 0 .34-.63.93.93 0 0 0-.33-.67.71.71 0 0 0 0-.14.17.17 0 0 0 .17-.16.17.17 0 0 0-.17-.17.19.19 0 0 0-.19.16.17.17 0 0 0 0 .1v.06a3.61 3.61 0 0 0-.86-.49 1 1 0 0 1 0-.17.17.17 0 0 0 .06-.27c1.12.44 1.8 1.07 1.79 1.76a1.29 1.29 0 0 1-.48.91l-.18.16a1.64 1.64 0 0 1-.22.14l-.21.13-.39.19-.23.09-.18.06h-.13a7.94 7.94 0 0 1-1 .25h-.38l-.55.07h-2.4a10.45 10.45 0 0 1-1.14-.13h-.3l-.26-.06h-.21l-.19-.05-.44-.12-.17-.06-.15-.05-.21-.08-.12-.05-.32-.15a4.7 4.7 0 0 1-.5-.29l-.25-.2a1.38 1.38 0 0 1-.58-1.07c-.04-1.21 2.44-2.17 5.59-2.1z'
        style={{
          fill: 'url(#s-5483b7a313-aN)',
        }}
        transform='translate(-2.92 -220.08)'
      />
      <path
        d='M949.92 380.83a.15.15 0 0 1-.13 0 .16.16 0 0 1 0-.22l4.57.08a.16.16 0 0 1 .22 0 .14.14 0 0 1 0 .21l-4.57-.07a.15.15 0 0 1-.09 0z'
        style={{
          fill: 'url(#s-5483b7a313-aO)',
        }}
        transform='translate(-2.92 -220.08)'
      />
    </g>
    <g
      id='volleyballNet'
    >
      <path
        d='M550.49 152.64v-40.29'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2px',
          stroke: 'url(#s-5483b7a313-aP)',
        }}
      />
      <path
        d='M545.85 133.03l-38.16 51.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M545.85 122.5l-37.53 48.58M545.85 124.26l-37.53 48.55M545.85 125.89l-37.53 48.69M545.85 127.53l-37.53 48.81M545.91 129.03l-37.59 48.93M545.85 130.46l-37.53 49.22M545.77 131.81l-37.45 49.65'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150000005960464px',
        }}
      />
      <path
        d='M510.32 165.91v15.38M509.65 166.3v15.38M508.82 167.32v15.38M510.97 165.07v15.2M511.66 164.17v15.04M512.37 162.97v15.39M513.01 162.14v15.19M513.71 161.23v15.04M514.46 160.43v15.39M515.11 159.6v15.19M515.81 158.69v15.04M516.51 157.5v15.38M517.15 156.66v15.2M517.85 155.76v15.04M518.57 155.08v15.38M519.22 154.24v15.2M519.92 153.34v15.04M520.62 152.15v15.38M521.26 151.31v15.19M521.96 150.41v15.03M522.6 149.71v15.38M523.25 148.87v15.2M523.95 147.97V163M524.65 146.77v15.39M525.3 145.94v15.19M525.99 145.6v13.9M526.74 144.8v14.25M527.39 143.96v14.06M528.09 143.06v13.9M528.79 141.87v14.24M529.44 141.03v14.06M530.14 140.13v13.9M530.85 139.45v14.25M531.5 138.61v14.06M532.2 137.71v13.9M532.9 136.51v14.25M533.55 135.68v14.06M534.24 134.77v13.9M534.93 133.82v13.9M535.67 133.02v14.25M536.32 132.19v14.06M537.02 131.28v13.9M537.72 130.09v14.25M538.37 129.25v14.06M539.07 128.35v13.9M539.78 127.67v14.25M540.43 126.83v14.06M541.13 125.93v13.9M541.83 124.74v14.24M542.48 123.9v14.06M543.18 122.99v13.91M543.75 122.09v14.25M544.39 121.26v14.06M545.09 120.35v13.91'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.150999993085861px',
        }}
      />
      <path
        d='M507.69 168.96l-7.87 9.28M507.82 183.94l-9.43 14.45M507.69 178.77l-7.87 10.82M545.85 119.92l4.76-6.31M545.91 129.03l4.63-5.67M545.91 132.84l4.58-4.97'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
        }}
      />
      <path
        d='M545.85 133.03v-13.11l-38.16 49.04v15.27'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-5483b7a313-f)',
        }}
      />
      <path
        d='M499.82 225.56v-50.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2px',
          stroke: 'url(#s-5483b7a313-aQ)',
        }}
      />
    </g>
    <g
      id='tennisNet'
    >
      <path
        d='M557.62 138.8l-67.54 99.33'
        style={{
          fill: 'none',
          stroke: '#fff',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        }}
      />
      <path
        d='M557.15 137.24l-67.07 98.45M557.15 135.27l-67.07 98.45M557.15 133.35l-67.07 98.46M557.15 131.39l-67.07 98.45M557.15 129.44l-67.07 98.45M557.15 127.47l-67.07 98.45M557.15 125.55L490.08 224M557.15 123.59l-67.07 98.45M557.15 121.7l-67.07 98.45M557.15 119.74l-67.07 98.45M557.15 117.82l-67.07 98.45M492.05 210.51v24.7M493.24 208.88v24.62M494.51 207.23l-.04 23.3M495.8 205.04l-.04 23.94M496.99 203.51l-.05 23.59M498.26 201.85l-.04 23.31M499.64 198.89l-.05 25.44M500.82 197.35l-.04 25.1M502.1 195.7l-.04 24.8M503.39 193.51v24.78M504.57 191.98v24.43M505.85 190.32v24.15M507.17 187.52l.04 25.07M508.35 185.99l.04 24.72M509.63 184.33l.04 24.44M510.92 182.15l.04 25.06M512.1 180.61l.06 23.86M513.38 178.96l.06 23.57M514.55 176.7l.06 25.18M515.74 175.16v24.9M517.02 173.5v24.67M518.3 171.32l.01 25.37M519.49 169.78v25.17M520.77 167.52v25.56M522.14 166.06v24.79M523.33 163.87v25.41M524.61 162.22v25.04M525.89 160.03l.01 25.27M527.08 157.83v25.76M528.36 156.17v25.38M529.67 154.93v24.67M530.86 153.39v24.49M532.19 151.97l-.06 24.07M533.47 149.78l-.05 24.73M534.66 148.25l-.06 24.56M535.89 144.87v25.8M537.14 143.13v25.73M538.51 141.67v24.1M539.7 138.13v25.77M540.97 136.48v25.47M542.26 134.29v26.11M543.45 132.76v25.76M544.72 131.1v25.47M546.04 129.86v26.1M547.23 128.32v25.76M548.5 126.67v25.47M549.79 124.48v26.11M550.98 122.95v25.76M552.25 121.29v25.47M553.3 119.64v26.11M554.48 118.11v25.76M555.76 116.45v25.48'
        style={{
          fill: 'none',
          stroke: '#333',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
        }}
      />
      <path
        d='M495.98 229.48v-24.64'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-5483b7a313-aR)',
        }}
      />
      <path
        d='M553.09 145.64v-25.7'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-5483b7a313-aS)',
        }}
      />
      <path
        d='M557.62 138.79V114.8l-67.54 98.86v24.47'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-5483b7a313-aT)',
        }}
      />
      <path
        d='M490.08 241.38v-27.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-5483b7a313-aU)',
        }}
      />
      <path
        d='M557.62 141.18V114.6'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '2.5px',
          stroke: 'url(#s-5483b7a313-aV)',
        }}
      />
    </g>
    <g
      id='unihockey'
    >
      <g
        id='unihockeyLeft'
      >
        <path
          d='M202.45 176.4l-43.49-3.18 40.64-25.68 40.87 2.72-38.02 26.14z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M184.79 386.87l-11.91-.75V385l20.86-12.45a3.13 3.13 0 0 1 2-.41l9.5 1.3v1.09L196 374a3.08 3.08 0 0 0-1.8.45l-16.7 10.12 7.27 1.23z'
          style={{
            fill: 'url(#s-5483b7a313-g)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M184.65 385.77l-11.77-.77 21-12.51a3.11 3.11 0 0 1 1.79-.43l10.11.64-.45.58a.41.41 0 0 1-.33.15l-9.14-.58a3.11 3.11 0 0 0-1.79.43l-18.61 11.1 10.39.66-.93.64a.35.35 0 0 1-.27.09z'
          style={{
            fill: 'url(#s-5483b7a313-aW)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M204.57 353.37a26.14 26.14 0 0 1-5.79-.58v-.11a26.79 26.79 0 0 0 6.25.58v.11zM204.52 352.79a23.72 23.72 0 0 1-5.49-.56v-.11a24.73 24.73 0 0 0 6 .56v.1zM204.62 354.53a28.3 28.3 0 0 1-6.06-.6v-.11a28.14 28.14 0 0 0 6.47.6v.11zM204.6 354a27.29 27.29 0 0 1-5.93-.59v-.11a27.79 27.79 0 0 0 6.36.59v.11zM204.54 355.58a29.2 29.2 0 0 1-6.13-.58v-.11a29.41 29.41 0 0 0 6.62.58v.11zM204.63 355a29.18 29.18 0 0 1-6.16-.61v-.11a29.5 29.5 0 0 0 6.56.61v.11zM204.59 356.75a31.53 31.53 0 0 1-6.47-.61v-.11a32.05 32.05 0 0 0 6.91.6v.11zM204.55 356.16a30.34 30.34 0 0 1-6.32-.58v-.11a30.52 30.52 0 0 0 6.8.58v.11zM204.64 357.91a33.93 33.93 0 0 1-6.74-.63v-.1a35.59 35.59 0 0 0 7.13.62v.11zM204.69 357.33a33.12 33.12 0 0 1-6.67-.68v-.11a32.79 32.79 0 0 0 7 .68v.1zM204.48 359.07a35.9 35.9 0 0 1-6.8-.58v-.11a36.83 36.83 0 0 0 7.35.58v.11zM204.65 358.49a35.08 35.08 0 0 1-6.86-.64v-.1a35.89 35.89 0 0 0 7.24.63v.11zM204.54 360.12a38.53 38.53 0 0 1-7.08-.6v-.1a39.16 39.16 0 0 0 7.57.59v.11zM204.5 359.54a37.13 37.13 0 0 1-6.93-.59v-.11a37.25 37.25 0 0 0 7.46.59v.11zM204.73 361.28a41.38 41.38 0 0 1-7.47-.73v-.11a40 40 0 0 0 7.77.73v.11zM204.56 360.7a39.83 39.83 0 0 1-7.21-.6v-.11a39.5 39.5 0 0 0 7.68.6v.11zM204.7 361.87a42.41 42.41 0 0 1-7.56-.71v-.11a41.55 41.55 0 0 0 7.89.71v.1zM204.62 363a45.23 45.23 0 0 1-7.72-.64v-.11a45.06 45.06 0 0 0 8.13.64v.11zM204.7 362.45a43.3 43.3 0 0 1-7.68-.71v-.11a43.42 43.42 0 0 0 8 .71v.11zM204.46 364.19a46.82 46.82 0 0 1-7.8-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM204.42 363.61a44.83 44.83 0 0 1-7.62-.58v-.11a45.17 45.17 0 0 0 8.23.58v.11zM204.5 365.36a49.85 49.85 0 0 1-8.07-.61v-.11a49.41 49.41 0 0 0 8.6.6v.11zM204.48 364.77a47.15 47.15 0 0 1-7.93-.6v-.1a49.14 49.14 0 0 0 8.49.59v.11zM204.52 366.41a51.15 51.15 0 0 1-8.29-.63v-.1a52.68 52.68 0 0 0 8.8.62v.1zM204.42 365.83a49.2 49.2 0 0 1-8.08-.59v-.1a50.92 50.92 0 0 0 8.7.57v.11zM204.42 367.57A54.21 54.21 0 0 1 196 367v-.11a54.44 54.44 0 0 0 9 .58v.11zM204.65 367a52.78 52.78 0 0 1-8.52-.72v-.1a53 53 0 0 0 8.9.71v.11zM204.37 368.73a55.51 55.51 0 0 1-8.6-.59V368a57.34 57.34 0 0 0 9.27.58v.11zM204.35 368.15a55 55 0 0 1-8.45-.58v-.11a55.7 55.7 0 0 0 9.14.58v.11zM204.42 369.9a59 59 0 0 1-8.88-.61v-.11a60.06 60.06 0 0 0 9.49.6v.11zM204.39 369.31a58.69 58.69 0 0 1-8.74-.59v-.11a58.61 58.61 0 0 0 9.38.59v.11zM204.46 371a63.37 63.37 0 0 1-9.12-.62v-.11a64 64 0 0 0 9.7.62v.1zM204.44 370.36a60.31 60.31 0 0 1-9-.61v-.1a61.16 61.16 0 0 0 9.58.6v.11zM204.36 372.11a66.15 66.15 0 0 1-9.26-.58v-.11a66.28 66.28 0 0 0 9.93.58v.11zM204.35 371.53a63.34 63.34 0 0 1-9.13-.58v-.11a66.58 66.58 0 0 0 9.82.58v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M192.91 152.41l-.11-.03 3.93-20.77.11.02-3.93 20.78zM193.8 152.41l-.11-.02 3.75-20.85.11.02-3.75 20.85zM200.81 152.95h-.11l.16-21.25h.11l-.16 21.25z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M192.49 362.27h21.2v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 90.16 253.657)'
        />
        <path
          d='M199.31 152.79h-.11l.44-21.1.11.01-.44 21.09zM196.67 152.64l-.11-.01 2.28-21.08.1.01-2.27 21.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M191.43 362.19h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.08 86.68 253.719)'
        />
        <path
          d='M189.52 362.06h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 74.153 253.73)'
        />
        <path
          d='M188.75 362.02h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 69.706 253.728)'
        />
        <path
          d='M197.73 152.64l-.11-.01 1.45-21.08.11.01-1.45 21.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M195.22 372.54l-.61-.12 3.88-19.75a1.68 1.68 0 0 1 1.74-1.35l5.34.32v.62l-5.34-.32a1.06 1.06 0 0 0-1.09.85z'
          style={{
            fill: 'url(#s-5483b7a313-aX)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M180.31 357.91h24.01v.08h-24.01z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -207.776 256.042)'
        />
        <path
          d='M176.92 357.88h24.47v.08h-24.47z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.58 -214.82 253.219)'
        />
        <path
          d='M178.38 143.92l-.04-.07 20.53-12.33.04.07-20.53 12.33zM177.69 143.8l-.04-.07 20.27-12.17.04.07-20.27 12.17zM176.71 143.92l-.04-.07 20.6-12.33.04.07-20.6 12.33z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M200.8 350.45h.08v3.27h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-86.86 83.148 243.59)'
        />
        <path
          d='M199.9 351.22h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.7 66.656 244.336)'
        />
        <path
          d='M197.65 133.27l-2.55-.63.02-.07 2.55.63-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M198.64 352.2h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.96 37 245.462)'
        />
        <path
          d='M198.02 352.57h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.46 34.878 245.853)'
        />
        <path
          d='M182.06 361.4h.08v4.01h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-85.98 62.61 254.937)'
        />
        <path
          d='M182.83 361.08h.08v3.47h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-84.68 60.62 254.365)'
        />
        <path
          d='M183.73 360.66h.08v3.21h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.67 54.981 253.915)'
        />
        <path
          d='M184.56 360.22h.08v3.11h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.3 52.686 253.463)'
        />
        <path
          d='M190.95 137.32l-3.04-.43.01-.07 3.04.43-.01.07zM191.85 136.78l-3.01-.43.01-.08 3.01.43-.01.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M185.53 359.65h.08v3.09h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.34 53.773 252.896)'
        />
        <path
          d='M186.34 359.25h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 49.019 252.475)'
        />
        <path
          d='M187.15 358.71h.08v3.04h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.91 54.368 251.93)'
        />
        <path
          d='M187.98 358.28h.08v2.91h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 50.668 251.5)'
        />
        <path
          d='M187.25 139.55l-2.87-.57.01-.08 2.88.58-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M189.6 357.25h.08v3.03h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.59 58.396 250.448)'
        />
        <path
          d='M196.86 352.85h.08v3.2h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.04 64.414 246.163)'
        />
        <path
          d='M195.75 134.41l-2.44-.71.02-.07 2.44.71-.02.07zM194.66 135.08l-2.77-.54.02-.08 2.76.55-.01.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M195.41 353.89h.08v2.77h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.21 61.018 247.002)'
        />
        <path
          d='M194.72 354.32h.08v2.8h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.13 57.748 247.482)'
        />
        <path
          d='M194.05 354.72h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-77.77 56.18 247.885)'
        />
        <path
          d='M191.67 356.07h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.64 58.269 249.243)'
        />
        <path
          d='M189.43 138.24l-2.84-.57.02-.08 2.83.57-.01.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M190.33 356.96h.08v2.76h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-75.78 47.525 250.176)'
        />
        <path
          d='M172.54 377.63h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -217.403 272.927)'
        />
        <path
          d='M172.57 377.05h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -217.362 272.35)'
        />
        <path
          d='M172.73 376.43H197v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -217.21 271.727)'
        />
        <path
          d='M172.91 375.89h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -217.024 271.19)'
        />
        <path
          d='M172.94 375.3h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -217.319 271.089)'
        />
        <path
          d='M173.1 374.69h24.27v.11H173.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -217.172 270.482)'
        />
        <path
          d='M173.16 374.19h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.787 269.474)'
        />
        <path
          d='M173.37 373.67h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.57 268.967)'
        />
        <path
          d='M173.4 373.08h24.27v.11H173.4z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.547 268.385)'
        />
        <path
          d='M173.56 372.47h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.377 267.767)'
        />
        <path
          d='M173.74 371.92h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.209 267.226)'
        />
        <path
          d='M173.77 371.34h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.163 266.631)'
        />
        <path
          d='M173.93 370.73h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -216.016 266.026)'
        />
        <path
          d='M173.99 370.23h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.954 265.514)'
        />
        <path
          d='M174.09 369.66h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.858 264.953)'
        />
        <path
          d='M174.12 369.08h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.818 264.377)'
        />
        <path
          d='M174.27 368.46h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.666 263.753)'
        />
        <path
          d='M174.45 367.92h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.48 263.217)'
        />
        <path
          d='M174.48 367.34h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.457 262.636)'
        />
        <path
          d='M174.64 366.72h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.305 262.012)'
        />
        <path
          d='M174.7 366.22h24.27v.11H174.7z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -215.248 261.519)'
        />
        <path
          d='M174.88 365.55h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -215.384 261.326)'
        />
        <path
          d='M175.03 364.93h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.911 260.222)'
        />
        <path
          d='M175.22 364.39h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.725 259.686)'
        />
        <path
          d='M175.25 363.81h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.702 259.104)'
        />
        <path
          d='M175.4 363.19h24.27v.11H175.4z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.532 258.486)'
        />
        <path
          d='M175.46 362.69h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.475 257.992)'
        />
        <path
          d='M175.56 362.13h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.38 257.431)'
        />
        <path
          d='M175.59 361.55h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -214.672 257.306)'
        />
        <path
          d='M175.75 360.93h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -214.187 256.231)'
        />
        <path
          d='M175.93 360.39h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -214.339 256.162)'
        />
        <path
          d='M175.96 359.8h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -213.973 255.096)'
        />
        <path
          d='M176.11 359.19h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -213.826 254.49)'
        />
        <path
          d='M176.17 358.69h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -213.764 253.979)'
        />
        <path
          d='M166.66 374h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 41.422 265.798)'
        />
        <path
          d='M167.83 373.28h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 42.594 265.078)'
        />
        <path
          d='M167.24 373.67h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 42 265.467)'
        />
        <path
          d='M168.34 373h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 43.11 264.798)'
        />
        <path
          d='M169.51 372.28h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 44.276 264.072)'
        />
        <path
          d='M168.92 372.66h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 43.682 264.461)'
        />
        <path
          d='M170.02 372h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 45.608 264.455)'
        />
        <path
          d='M171.19 371.28h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 45.953 263.073)'
        />
        <path
          d='M170.6 371.66h20.58v.11H170.6z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 45.359 263.462)'
        />
        <path
          d='M171.71 370.99h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 46.469 262.793)'
        />
        <path
          d='M172.88 370.27h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 47.635 262.067)'
        />
        <path
          d='M172.28 370.66h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 47.04 262.456)'
        />
        <path
          d='M173.39 370.05h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 48.15 261.848)'
        />
        <path
          d='M174.56 369.33h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 49.323 261.128)'
        />
        <path
          d='M173.97 369.71h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 48.728 261.506)'
        />
        <path
          d='M175.08 369.04h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 49.833 260.843)'
        />
        <path
          d='M176.24 368.32h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 51.835 260.753)'
        />
        <path
          d='M175.65 368.71h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 50.415 260.505)'
        />
        <path
          d='M176.76 368.05h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 51.522 259.853)'
        />
        <path
          d='M177.93 367.33h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 52.694 259.133)'
        />
        <path
          d='M177.34 367.72h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 52.093 259.517)'
        />
        <path
          d='M178.44 367.05h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 53.203 258.848)'
        />
        <path
          d='M179.61 366.33h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 54.376 258.127)'
        />
        <path
          d='M179.02 366.71h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 53.775 258.511)'
        />
        <path
          d='M180.12 366.05h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 54.886 257.853)'
        />
        <path
          d='M181.29 365.33h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 56.052 257.128)'
        />
        <path
          d='M180.7 365.71h20.58v.11H180.7z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 55.463 257.51)'
        />
        <path
          d='M181.81 365.04h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 57.405 257.453)'
        />
        <path
          d='M182.98 364.32h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 58.573 256.723)'
        />
        <path
          d='M182.38 364.71h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 57.145 256.505)'
        />
        <path
          d='M183.49 364.1h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 58.255 255.897)'
        />
        <path
          d='M184.66 363.38h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 59.428 255.177)'
        />
        <path
          d='M184.07 363.76h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 58.827 255.56)'
        />
        <path
          d='M185.17 363.1h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 59.937 254.892)'
        />
        <path
          d='M185.75 362.76h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 60.509 254.555)'
        />
        <path
          d='M183.88 365.67a26.14 26.14 0 0 1-5.79-.58v-.11a25.75 25.75 0 0 0 6.25.58v.11zM183.83 365.09a23.72 23.72 0 0 1-5.49-.56v-.1a24.75 24.75 0 0 0 6 .55v.11zM183.93 366.84a27.66 27.66 0 0 1-6.06-.61v-.1a28.7 28.7 0 0 0 6.47.6v.1zM183.91 366.26a27.28 27.28 0 0 1-5.93-.6v-.1a27.81 27.81 0 0 0 6.36.58v.11zM183.85 367.89a28.54 28.54 0 0 1-6.13-.59v-.1a30 30 0 0 0 6.62.58v.1zM183.94 367.31a28.51 28.51 0 0 1-6.16-.62v-.1a28.94 28.94 0 0 0 6.56.6v.11zM183.9 369.05a31.6 31.6 0 0 1-6.47-.61v-.1a32.05 32.05 0 0 0 6.91.6v.11zM183.86 368.47a31 31 0 0 1-6.32-.58v-.11a31.76 31.76 0 0 0 6.8.58v.11zM184 370.21a34.72 34.72 0 0 1-6.74-.62v-.11a34.12 34.12 0 0 0 7.13.62v.11zM184 369.63a33.12 33.12 0 0 1-6.67-.68v-.1a33.43 33.43 0 0 0 7 .67v.11zM183.79 371.38a35.07 35.07 0 0 1-6.8-.59v-.1a36.83 36.83 0 0 0 7.35.58v.1zM184 370.79a35.1 35.1 0 0 1-6.86-.63v-.11a35.18 35.18 0 0 0 7.24.63v.11zM183.86 372.43a38.57 38.57 0 0 1-7.09-.6v-.11a39.13 39.13 0 0 0 7.57.6v.1zM183.81 371.85a36.28 36.28 0 0 1-6.93-.6v-.1a37.28 37.28 0 0 0 7.46.58v.11zM184 373.59a41.38 41.38 0 0 1-7.47-.73v-.11a40.88 40.88 0 0 0 7.77.73v.11zM183.87 373a39.8 39.8 0 0 1-7.21-.61v-.11a40.27 40.27 0 0 0 7.68.61v.11zM184 374.17a41.5 41.5 0 0 1-7.56-.71v-.1a42.35 42.35 0 0 0 7.89.7v.11zM183.93 375.33a44.24 44.24 0 0 1-7.72-.64v-.11a44.24 44.24 0 0 0 8.13.64v.11zM184 374.75a43.3 43.3 0 0 1-7.68-.71v-.11a42.57 42.57 0 0 0 8 .71v.11zM183.77 376.5a46.82 46.82 0 0 1-7.8-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM183.73 375.92a43.8 43.8 0 0 1-7.62-.59v-.1a46.08 46.08 0 0 0 8.23.58v.1zM183.81 377.66a48.74 48.74 0 0 1-8.07-.61v-.1a51.45 51.45 0 0 0 8.6.6v.11zM183.79 377.08a48.22 48.22 0 0 1-7.93-.6v-.11a49.1 49.1 0 0 0 8.49.6v.11zM183.82 378.71a51.16 51.16 0 0 1-8.28-.62v-.11a52.68 52.68 0 0 0 8.8.62v.11zM183.73 378.13a50.4 50.4 0 0 1-8.08-.58v-.11a50.84 50.84 0 0 0 8.7.58v.11zM183.73 379.87a53 53 0 0 1-8.39-.58v-.11a53.37 53.37 0 0 0 9 .58v.11zM184 379.29a52.77 52.77 0 0 1-8.53-.71v-.11a52.87 52.87 0 0 0 8.9.71v.11zM183.68 381a56.78 56.78 0 0 1-8.6-.59v-.11a58.45 58.45 0 0 0 9.27.59v.11zM183.66 380.46a53.72 53.72 0 0 1-8.45-.59v-.1a55.75 55.75 0 0 0 9.14.57v.11zM183.73 382.2a60.39 60.39 0 0 1-8.88-.6v-.11a60.06 60.06 0 0 0 9.49.6v.11zM183.7 381.62a57.33 57.33 0 0 1-8.7-.62v-.11a58.64 58.64 0 0 0 9.38.6v.11zM183.77 383.25a62 62 0 0 1-9.12-.62v-.1a65.36 65.36 0 0 0 9.7.61v.11zM183.75 382.67a61.68 61.68 0 0 1-9-.61v-.11a62.33 62.33 0 0 0 9.58.61v.11zM183.67 384.41a64.66 64.66 0 0 1-9.26-.58v-.11a65.05 65.05 0 0 0 9.93.58v.11zM183.66 383.83a63.34 63.34 0 0 1-9.13-.58v-.11a64 64 0 0 0 9.82.58v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M172.22 164.71l-.11-.02 3.93-20.77.11.02-3.93 20.77zM173.11 164.71l-.11-.02 3.75-20.84.11.02-3.75 20.84zM180.12 165.25h-.11l.16-21.24h.11l-.16 21.24z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M171.8 374.58H193v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 69.477 265.942)'
        />
        <path
          d='M178.62 165.1h-.11l.44-21.1h.11l-.44 21.1zM175.98 164.95l-.11-.01 2.28-21.09.1.01-2.27 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M170.75 374.5h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.08 65.996 266.024)'
        />
        <path
          d='M168.83 374.36h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 53.469 266.038)'
        />
        <path
          d='M168.06 374.32h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 49.021 266.031)'
        />
        <path
          d='M177.04 164.95l-.11-.01 1.45-21.09.11.01-1.45 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M174.38 384.87l-.61-.12 3.88-19.75a1.68 1.68 0 0 1 1.74-1.34l5.34.31v.62l-5.34-.31a1.05 1.05 0 0 0-1.09.84z'
          style={{
            fill: 'url(#s-5483b7a313-aY)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M184.86 386.72l-1-.41.07-22.07a1.53 1.53 0 0 1 .75-1.32l20.15-12.18a.4.4 0 0 1 .32 0l.75.22a.4.4 0 0 1 .28.39l-.93 23.24-.93-.06v-21.7a.39.39 0 0 0-.59-.33l-18.12 10.94a1.57 1.57 0 0 0-.75 1.33z'
          style={{
            fill: 'url(#s-5483b7a313-aZ)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M185.08 386.59l-.29.28.07-22.1a1.57 1.57 0 0 1 .75-1.33l20-12.07a.39.39 0 0 1 .59.34v20.63a3.11 3.11 0 0 1-.92 2.2v-21.18a.39.39 0 0 0-.59-.33L186.55 364a1.54 1.54 0 0 0-.75 1.33v19.54a2.51 2.51 0 0 1-.72 1.72z'
          style={{
            fill: 'url(#s-5483b7a313-ba)',
          }}
          transform='translate(-2.92 -220.08)'
        />
      </g>
      <g
        id='unihockeyRight'
      >
        <path
          d='M928.9 226.41l-50.89-3.71-4.01-31.69 45.53 2.54 9.37 32.86z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M916.93 218.34l10.95.63v-1l-6.54-19.46-9.71.21v1l8.5.48 5.45 17.04-8.65.1v1z'
          style={{
            fill: 'url(#s-5483b7a313-bb)',
          }}
        />
        <path
          d='M916.95 217.34l10.93.63-6.54-19.46-10.16-.47.53.68 9.03.51 5.86 18.06-9.85-.56.2.61z'
          style={{
            fill: 'url(#s-5483b7a313-bc)',
          }}
        />
        <path
          d='M923.8 419.59c-1 0-2.08 0-3.29-.13v-.1a36.92 36.92 0 0 0 7-.08v.1a34.17 34.17 0 0 1-3.71.21zM923.74 419.06c-1 0-2 0-3.18-.13v-.1a33.3 33.3 0 0 0 6.73-.07v.1a31.9 31.9 0 0 1-3.55.2zM923.78 420.64c-1.06 0-2.17 0-3.36-.13v-.1a38.74 38.74 0 0 0 7.26-.08v.1a36.22 36.22 0 0 1-3.9.21zM923.78 420.11c-1 0-2.12 0-3.31-.13v-.1a37.51 37.51 0 0 0 7.14-.07v.1a35.15 35.15 0 0 1-3.83.2zM924 421.61c-1.12 0-2.29-.05-3.62-.15v-.1a39.81 39.81 0 0 0 7.43-.05v.1c-1.36.13-2.57.2-3.81.2zM923.78 421.07c-1.08 0-2.21-.05-3.4-.13v-.1a40.71 40.71 0 0 0 7.36-.08v.1a36.92 36.92 0 0 1-3.96.21zM924 422.66c-1.18 0-2.41-.05-3.74-.14v-.1a45.28 45.28 0 0 0 7.75-.05v.09a38.24 38.24 0 0 1-4.01.2zM924.1 422.14c-1.18 0-2.42-.05-3.81-.15v-.1a42.75 42.75 0 0 0 7.62 0v.1a37.21 37.21 0 0 1-3.81.15zM924 423.71c-1.24 0-2.52 0-3.84-.14v-.1a47.18 47.18 0 0 0 8-.05v.1c-1.32.13-2.72.19-4.16.19zM923.52 423.16c-1.1 0-2.19 0-3.32-.12v-.1a44.94 44.94 0 0 0 7.86-.1v.1c-1.55.15-3.06.22-4.54.22zM924.37 424.79c-1.33 0-2.71-.05-4.31-.17v-.1a50.36 50.36 0 0 0 8.24 0v.1c-1.3.12-2.61.17-3.93.17zM924 424.24c-1.26 0-2.57-.05-3.88-.14v-.1a49.65 49.65 0 0 0 8.12-.06v.1c-1.32.13-2.76.2-4.24.2zM924.41 425.74c-1.39 0-2.84-.05-4.43-.17v-.1a53.46 53.46 0 0 0 8.49 0v.1c-1.34.12-2.67.17-4.06.17zM924.4 425.22c-1.36 0-2.77-.06-4.37-.17V425a50.65 50.65 0 0 0 8.36 0v.1c-1.39.06-2.65.12-3.99.12zM923.47 426.75c-1.12 0-2.32 0-3.58-.12v-.1a54.92 54.92 0 0 0 8.72-.11v.1c-1.4.12-3.14.23-5.14.23zM924.43 426.27c-1.43 0-2.91-.06-4.5-.17v-.1a55.11 55.11 0 0 0 8.62 0v.09c-1.34.13-2.7.18-4.12.18zM923.74 427.29c-1.32 0-2.61 0-3.9-.14v-.09a57.07 57.07 0 0 0 8.85-.08v.1c-1.69.14-3.33.21-4.95.21zM924.51 428.38c-1.56 0-3.17-.06-4.76-.17v-.1a61.62 61.62 0 0 0 9.12 0v.1c-1.34.11-2.87.17-4.36.17zM923.8 427.82c-1.36 0-2.69 0-4-.14v-.1a58.79 58.79 0 0 0 9-.06v.1c-1.69.13-3.36.2-5 .2zM925 429.47c-1.66 0-3.38-.07-5.32-.21v-.1a65.69 65.69 0 0 0 9.38.07v.1c-1.38.09-2.71.14-4.06.14zM924.92 428.94c-1.61 0-3.26-.07-5.21-.21v-.09a62 62 0 0 0 9.22.06v.1c-1.39.09-2.68.14-4.01.14zM925.05 430.52c-1.73 0-3.54-.07-5.48-.2v-.1a69.22 69.22 0 0 0 9.63.07v.09c-1.35.1-2.73.14-4.15.14zM925 430c-1.7 0-3.46-.06-5.41-.2v-.1a67.51 67.51 0 0 0 9.51.07v.1c-1.34.13-2.69.13-4.1.13zM925.29 431.48c-1.66 0-3.38-.07-5.32-.21v-.1a65.56 65.56 0 0 0 9.37.07v.1c-1.34.09-2.68.14-4.05.14zM925.39 431c-1.81 0-3.73-.08-5.86-.23v-.1a69.8 69.8 0 0 0 9.74.1v.1c-1.27.05-2.53.13-3.88.13zM925.83 432.56c-1.73 0-3.58-.07-5.81-.23v-.1a66 66 0 0 0 9.45.11v.1c-1.19.08-2.38.12-3.64.12zM924.58 432c-1.52 0-3 0-4.61-.17v-.1a64.64 64.64 0 0 0 9.44 0v.1c-1.73.08-3.3.17-4.83.17zM925.86 433.62c-1.68 0-3.37-.07-5.67-.23v-.1a67.71 67.71 0 0 0 9.49.12v.1c-1.42.07-2.62.11-3.82.11zM925.78 433.1c-1.64 0-3.29-.08-5.59-.24v-.1a64.86 64.86 0 0 0 9.39.12v.1c-1.42.08-2.58.12-3.8.12zM925.33 434.71c-1.57 0-3.21-.06-5.27-.21v-.1a70 70 0 0 0 9.79.06v.1c-1.63.09-3.04.15-4.52.15zM925.91 434.15c-1.74 0-3.5-.08-5.79-.24v-.1a68.56 68.56 0 0 0 9.65.13v.1c-1.4.07-2.63.11-3.86.11zM925.4 435.66c-1.62 0-3.34-.06-5.43-.21v-.1a73.34 73.34 0 0 0 10 .07v.1c-1.56.08-2.97.14-4.57.14zM925.36 435.13c-1.59 0-3.27-.06-5.34-.2v-.1a71.3 71.3 0 0 0 9.88.06v.1c-1.59.09-3.02.14-4.54.14zM926 436.74c-1.92 0-3.85-.08-6.08-.23v-.1a77.1 77.1 0 0 0 10.27.11v.1c-1.48.08-2.85.12-4.19.12zM925.84 436.21c-1.87 0-3.73-.08-5.91-.23v-.1a75.2 75.2 0 0 0 10.15.11v.1a78.3 78.3 0 0 1-4.24.12z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M926.41 217.59l-2.3-19.24.1-.01 2.3 19.23-.1.02z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M927.36 418.24h.1v19.56h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-5.8 -1246.774 346.613)'
        />
        <path
          d='M917.92 217.14h-.1l.08-19.18h.1l-.08 19.18zM918.59 217.12h-.1l.08-19.08h.1l-.08 19.08zM919.31 217.25h-.1l.14-19.21h.1l-.14 19.21z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M924.83 418.2h.1v19.19h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.57 -7107.003 424.553)'
        />
        <path
          d='M920.19 198.04h.1v19.28h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M925.53 418.22h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-2.39 -4350.17 388.139)'
        />
        <path
          d='M926.5 418.24h.1v19.48h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.12 -2134.66 358.317)'
        />
        <path
          d='M923.94 418.12h.1v19.3h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.81 -14647.148 523.201)'
        />
        <path
          d='M917.36 401c-.7 0-1.44 0-2.26-.07v-.1a29.11 29.11 0 0 0 6.2-.21v.09a26.52 26.52 0 0 1-3.94.29zM917.37 400.47c-.68 0-1.4 0-2.24-.08v-.1a26.31 26.31 0 0 0 6-.21v.1a24.21 24.21 0 0 1-3.76.29zM917.29 402q-1.06 0-2.25-.06v-.1a30.61 30.61 0 0 0 6.43-.23v.1a28.75 28.75 0 0 1-4.18.29zM917.31 401.5c-.7 0-1.44 0-2.24-.07v-.1a29.47 29.47 0 0 0 6.31-.22v.1a27.68 27.68 0 0 1-4.07.29zM917.47 403c-.77 0-1.58 0-2.48-.08v-.1a32.83 32.83 0 0 0 6.58-.2v.1a30 30 0 0 1-4.1.28zM917.27 402.44q-1.08 0-2.25-.06v-.1a32.19 32.19 0 0 0 6.52-.23v.1a29.67 29.67 0 0 1-4.27.29zM917.43 404c-.8 0-1.63 0-2.51-.08v-.1a34.89 34.89 0 0 0 6.86-.21v.1a32.84 32.84 0 0 1-4.35.29zM917.54 403.5c-.81 0-1.66 0-2.58-.08v-.1a34.35 34.35 0 0 0 6.75-.19v.1a31.57 31.57 0 0 1-4.17.27zM917.36 405.06c-.82 0-1.65 0-2.5-.08v-.1a37.21 37.21 0 0 0 7.08-.21v.1a35.48 35.48 0 0 1-4.58.29zM917 404.53c-.7 0-1.41 0-2.14-.07v-.1a36.16 36.16 0 0 0 7-.26v.1a36.45 36.45 0 0 1-4.86.33zM917.75 406.12c-.91 0-1.88 0-3-.09v-.1a39.5 39.5 0 0 0 7.29-.17v.1a35.66 35.66 0 0 1-4.29.26zM917.33 405.58c-.82 0-1.66 0-2.5-.08v-.09a39.22 39.22 0 0 0 7.19-.22v.1a36.76 36.76 0 0 1-4.69.29zM917.7 407.06c-.94 0-1.91 0-3-.09v-.1a42.08 42.08 0 0 0 7.52-.17v.1a40.41 40.41 0 0 1-4.52.26zM917.74 406.54c-.92 0-1.9 0-3-.09v-.1a40.69 40.69 0 0 0 7.4-.17v.1a39.1 39.1 0 0 1-4.4.26zM916.92 408.07c-.72 0-1.46 0-2.24-.06v-.1a43.49 43.49 0 0 0 7.72-.28v.1a47.32 47.32 0 0 1-5.48.34zM917.69 407.58c-1 0-1.94 0-3-.09v-.1a43.31 43.31 0 0 0 7.63-.17v.1a41.62 41.62 0 0 1-4.63.26zM917.1 408.6c-.82 0-1.64 0-2.45-.07v-.1a44.33 44.33 0 0 0 7.84-.25v.1a46.09 46.09 0 0 1-5.39.32zM917.62 409.66c-1 0-2 0-3-.08v-.1a49.57 49.57 0 0 0 8.07-.18v.09a44.57 44.57 0 0 1-5.07.27zM917.12 409.12c-.85 0-1.68 0-2.5-.07V409a46.36 46.36 0 0 0 8-.24v.1a48.54 48.54 0 0 1-5.5.26zM918.1 410.73c-1.12 0-2.29 0-3.57-.11v-.1a52.77 52.77 0 0 0 8.31-.12v.1c-1.59.15-3.11.23-4.74.23zM918.12 410.21c-1.1 0-2.26 0-3.56-.11v-.1a49.86 49.86 0 0 0 8.17-.12v.1c-1.59.15-3.05.23-4.61.23zM918.09 411.77c-1.16 0-2.36 0-3.62-.11v-.1a54.38 54.38 0 0 0 8.53-.12v.1c-1.59.15-3.21.23-4.91.23zM918.1 411.25c-1.14 0-2.33 0-3.6-.11V411a53 53 0 0 0 8.42-.12v.1c-1.59.19-3.16.27-4.82.27zM918.09 412.71c-1.18 0-2.41 0-3.68-.11v-.1a55.67 55.67 0 0 0 8.73-.13v.1c-1.61.16-3.28.24-5.05.24zM918.38 412.2c-1.23 0-2.53 0-3.94-.12V412a54 54 0 0 0 8.62-.1v.1a46.63 46.63 0 0 1-4.68.2zM918.55 413.77q-2 0-4.2-.12v-.1a59 59 0 0 0 8.93-.09v.1c-1.42.14-3.01.21-4.73.21zM917.41 413.21c-1 0-2 0-3-.08V413a57.26 57.26 0 0 0 8.83-.21v.1c-2.02.22-3.94.32-5.83.32zM918.56 414.82c-1.33 0-2.72 0-4.27-.13v-.1a63.34 63.34 0 0 0 9.19-.08v.1c-1.67.14-3.25.21-4.92.21zM918.55 414.3c-1.3 0-2.67 0-4.23-.13v-.1a61.71 61.71 0 0 0 9.07-.08v.1c-1.67.14-3.21.21-4.84.21zM918.57 415.86c-1.37 0-2.8 0-4.35-.13v-.1a65 65 0 0 0 9.41-.08v.1c-1.63.14-3.32.21-5.06.21zM918.57 415.34c-1.35 0-2.76 0-4.31-.13v-.1a63.45 63.45 0 0 0 9.3-.08v.1c-1.67.14-3.29.21-4.99.21zM918.57 416.8c-1.41 0-2.87 0-4.4-.12v-.1a69.38 69.38 0 0 0 9.62-.09v.1c-1.67.14-3.41.21-5.22.21zM918.57 416.28c-1.39 0-2.84 0-4.37-.13v-.1a66.26 66.26 0 0 0 9.5-.08v.1c-1.7.14-3.36.21-5.13.21zM919.09 417.86c-1.56 0-3.23 0-5-.14v-.1a72.6 72.6 0 0 0 9.85 0v.1c-1.46.08-3.09.14-4.85.14zM919 417.34c-1.52 0-3.14 0-4.87-.14v-.1a70.92 70.92 0 0 0 9.74-.05v.1c-1.5.13-3.12.19-4.87.19z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M922.04 399.69h.1v19.11h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-7.17 -835.662 322.523)'
        />
        <path
          d='M921.32 399.58h.1v19.31h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-6.26 -1093.094 325.588)'
        />
        <path
          d='M912.45 198.53l-.03-19.11h.1l.03 19.11h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M916.04 399.6h.1v18.95h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.13 -96056.064 1596.68)'
        />
        <path
          d='M916.81 399.6h.1v18.94h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.31 -39774.96 833.162)'
        />
        <path
          d='M916.56 198.45l-.81-18.94h.1l.81 18.94h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M917.6 399.6h.1v18.99h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.75 -15896.953 521.641)'
        />
        <path
          d='M919.7 399.59h.1v19.1h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-3.2 -3021.376 351.28)'
        />
        <path
          d='M920.56 399.59h.1v19.24h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.75 -1734.463 334.182)'
        />
        <path
          d='M918.35 399.5h.1v19.09h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.41 -8027.35 416.936)'
        />
        <path
          d='M923.67 419l-2.19-18.14c-.07-.78-.94-.92-1.66-.9l-6-.2v-.57l6 .2c1.89 0 2.18 1 2.22 1.42l2.19 18.12z'
          style={{
            fill: 'url(#s-5483b7a313-bd)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M924.37 420.28l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M924.84 421.56l-2.19-18.13a1.31 1.31 0 0 0-1.25-1.18l-6-.2V402l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M925.34 423.17L923.15 405a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M925.79 424.32l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M926.25 425.66l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2V406l6 .2a1.4 1.4 0 0 1 1.34 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M926.72 427l-2.19-18.13a1.32 1.32 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.43 1.43 0 0 1 1.34 1.28l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M927.22 428.62L925 410.49a1.31 1.31 0 0 0-1.24-1.19l-6-.19V409l6 .19a1.42 1.42 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M927.71 430l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.15z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M928.18 431.47L926 413.34a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M928.66 432.91l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M929.17 434.65L927 416.51a1.31 1.31 0 0 0-1.24-1.18l-6-.2V415l6 .2a1.42 1.42 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M929.64 436l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.28l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M929.9 437.58l-2.19-18.13a1.08 1.08 0 0 0-1-1l-6.38-.19v-.57l6.38.19a1.65 1.65 0 0 1 1.57 1.49l2.19 18.13z'
          style={{
            fill: 'url(#s-5483b7a313-be)',
          }}
          transform='translate(-2.92 -220.08)'
        />
        <path
          d='M918.31 398.96h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.86 216.36 307.822)'
        />
        <path
          d='M919.46 399.07h.1v19.37h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.47 201.838 308.221)'
        />
        <path
          d='M920.52 198.05l-5.71-18.56.1-.03 5.71 18.56-.1.03zM921.81 198.05l-6.09-18.61.1-.03 6.09 18.61-.1.03zM922.88 198.06l-6.31-18.52.09-.04 6.31 18.52-.09.04z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M923.76 399.21h.1v19.52h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-18.69 253.852 307.84)'
        />
        <path
          d='M920.06 438.62a.57.57 0 0 1-.57-.57v-20.11l-4.72-14.73v16.45a.56.56 0 0 1-.57.57.57.57 0 0 1-.57-.57v-20.11a.57.57 0 0 1 1.12-.17l5.83 18.2a.7.7 0 0 1 0 .25v20.22a.58.58 0 0 1-.52.57z'
          style={{
            fill: 'url(#s-5483b7a313-bf)',
          }}
          transform='translate(-2.92 -220.08)'
        />
      </g>
    </g>
  </Fragment>
)

const defaultProps = {
  children,
  viewBox,
  fillColor: null,
  fillColorRule: '&&& path, &&& use, &&& g',
  size: null
}

const propTypes = {
  fillColor: PropTypes.string,
  fillColorRule: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    })
  ]),
  sizes: (props, name, componentName) => {
    const prop = props[name]
    if (typeof prop !== 'object') { return }
    for (let key in prop) {
      if (!prop[key] || typeof prop[key].width !== 'number' || typeof prop[key].height !== 'number') {
        return new Error(
          'Invalid prop `' + name + '` supplied to `' + componentName + '`. Validation failed.'
        )
      }
    }
  }
}

export default Object.assign(Image, {
  getDimensions,
  getCss,
  defaultProps,
  propTypes,
  displayName: '36x18'
})
